<template>
    <div class="lq-page-content" :class="{ 'is-loading': isLoading }">
        <input type="hidden" id="lqVersion" :value="lqVersion" />
        <input type="hidden" id="groupid" :value="groupid" />
        <input type="hidden" id="PayWarn" value />
        <input type="hidden" id="txtload" :value="txtload" />
        <!-- 用户权限 -->
        <input type="hidden" id="rolejson" value />
        <input type="hidden" id="WebidHidden" :value="webid" />
        <input type="hidden" id="txtLoginSite" :value="txtLoginSite" />
        <input type="hidden" id="isbaozhangda" :value="isbaozhangda" />
        <input type="hidden" id="storeData" :value="storeData" />

        <!-- 公司logo -->
        <div class="logo-outer">
            <a :href="lqBaseUrl + '/home/index'"><img :src="logopath" id="TMS-logo" /></a>
            <p class="logo-outer-p">
                <span>
                    {{ userText }}
                    <a
                        href="javascript:;"
                        id="tooltip"
                        data-tip="基于蓝桥公司用户的同意，向持有蓝桥公司企业ID及对应运单号的合作方用户提供运单数据以便合作方可随时查看及跟进运单数据，在实践中常常表现为蓝桥公司用户上级公司或上游货主，存在实时查看运单进度需求及存储运单信息的需求。"
                        data-direction="bottom"
                    >
                        !
                    </a>
                </span>

                <span>【当前网点：{{ webid }}】</span>
            </p>
            <input type="hidden" id="HomeloginSite" :value="webid" />
        </div>

        <!-- 左上角图标 -->
        <div class="top-menu-body">
            <div class="top-menu-part">
                <a class="top-menu-pic" onclick="toggleLeftMenu()" title="切换菜单">
                    <i class="top-menu-icon l-icon-menu"></i>
                </a>
            </div>
            <div class="top-menu-part">
                <a class="top-menu-pic" :href="lqBaseUrl + '/home/index'">
                    <i class="top-menu-icon l-icon-home"></i>
                </a>
            </div>
            <div class="top-menu-part">
                <a class="top-menu-pic" style="padding: 4px">
                    <img id="userimgBig" :class="{ userImeg: 'userimgBig' }" :src="userImeg" @error.once="onErrorImg" />
                </a>
                <div class="hide-menu user-info-menu">
                    <div class="user-baseinfo">
                        <div class="user-baseinfo-left" title="点击上传用户头像" id="uploadUserAvatar">
                            <img id="userimg" :src="userImeg" @error.once="onErrorImg" />
                        </div>
                        <div class="user-baseinfo-right">
                            <div>
                                <span>企业ID：{{ webid }}</span>
                                <span>|</span>

                                <span>{{ gsname }}</span>
                                <span>|</span>
                                <span id="CookiesLoginSite">{{ webid }}</span>
                                <span>|</span>
                                <span id="username">{{ userName }}</span>
                            </div>
                            <div>
                                <span>
                                    运单模板：
                                    <span id="tydname"></span>
                                </span>
                                <span>|</span>
                                <span>
                                    标签模板：
                                    <span id="bqname"></span>
                                </span>
                            </div>
                            <div>
                                <span>
                                    清单模板：
                                    <span id="qdname"></span>
                                </span>
                                <span>|</span>
                                <span>
                                    信封模板：
                                    <span id="xfname"></span>
                                </span>
                                <template v-if="ruilangprint">
                                    <span>|</span>
                                    <span>
                                        打印版本：
                                        <span id="cjname">{{ versionName }}</span>
                                    </span>
                                </template>
                            </div>
                        </div>
                        <div class="auth-swap" @click="getAuthCode" v-if="!isAutoLogin && !isC9BSCallCar">
                            <div>
                                <img style="width: 44px; height: 44px" src="https://imagecdn.ymm56.com/ymmfile/static/resource/056aaa55-e26e-4e76-b774-289ac7aeba20.png" />
                            </div>
                            <div class="auth-swap-text">授权代操作</div>
                        </div>
                        <div class="claer"></div>
                    </div>
                    <div class="user-baseinfo user-baseinfo-last">
                        <!-- https://imagecdn.ymm56.com/ymmfile/static/resource/b3511288-db01-448c-9ad6-86deb7b0b7b4.png -->
                        <div class="user-baseinfo-title">个人中心</div>
                        <div class="user-item">
                            <div class="user-part changes" v-if="!isC9BSCallCar" onclick="openHomeNoteRecharge()" style="margin-left: 10px">
                                <div class="user-part-img">
                                    <img style="width: 50px; height: 50px" src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-homeNoteRecharge.png" />
                                </div>
                                <div class="user-part-label sitename">短信充值</div>
                            </div>
                            <div class="user-part changes" v-if="!isC9BSCallCar" onclick="openToggleSiteWin()" id="switchSite">
                                <div class="user-part-img">
                                    <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-qiehuanzd.png" />
                                </div>
                                <div class="user-part-label sitename">切换网点</div>
                            </div>
                            <div class="user-part" v-if="!isC9BSCallCar" id="leaveState">
                                <div class="user-part-img">
                                    <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-zslk.png" />
                                </div>
                                <div class="user-part-label">暂时离开</div>
                            </div>
                            <div class="user-part set-print-btn" v-if="!isC9BSCallCar" onclick="handleSetPrintBtnClick()">
                                <div class="user-part-img">
                                    <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-dayin.png" />
                                </div>
                                <div class="user-part-label">打印设置</div>
                            </div>
                            <div class="user-part" onclick="openChangePsd('')">
                                <div class="user-part-img">
                                    <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-top-gdsq.png" />
                                </div>
                                <div class="user-part-label">修改密码</div>
                            </div>
                            <div class="user-part" @click="switchNewVersion()">
                                <div class="user-part-img">
                                    <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/677cda7f-4d0c-4f71-81d3-ff34c2093e1e.png" />
                                </div>
                                <div class="user-part-label">切换新版</div>
                            </div>
                            <div class="user-part exit">
                                <div class="user-part-img">
                                    <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-zxdl.png" />
                                </div>
                                <div class="user-part-label">注销登录</div>
                            </div>
                            <div class="claer"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <homeHeader ref="HomeHeader" :hasBindCYS="hasBindCYS" @privacyButtons="privacyButtons" />
        <impowerLogin ref="impowerLogin" />

        <!-- 存在优先级判断，如果出了新手服务弹框，就不弹下面的弹框 -->
        <popupDefinition :hasNewWXServiceAd="hasNewWXServiceAd" v-if="showPopupDefinition" @noticeButtons="noticeButtons" />
        <div class="menuTag">
            <i class="l-icon-lArrow"></i>
            <span></span>
        </div>
        <div id="layout1" style="width: 99.2%; margin: 0 auto; margin-top: 4px">
            <div position="left" id="accordion1">
                <span class="scrollBtn" id="upBtn">
                    <i></i>
                    <u></u>
                </span>
                <span id="menuScrollBody">
                    <ul id="menuUl" v-if="isC9BSCallCar">
                        <li class="big-menu ylzy-menu" v-show="isUserEnableOneCarKey">
                            <a class="l-link-item l-link" data-tabid="oneKeyCar" data-text="询价调车">
                                <i class="menu-icon l-icon-ylzy"></i>
                                <span>询价调车</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu xjdc-child-menu">
                                <div id="xjdcTree"></div>
                            </div>
                        </li>

                        <!-- 司机履约管理 -->
                        <li class="big-menu ylzy-menu" v-show="isEnableLandingDispatch">
                            <a class="l-link-item l-link" data-tabid="landingDispatch" data-text="司机履约">
                                <i class="menu-icon l-icon-ylzy"></i>
                                <span>司机履约</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu landing-child-menu">
                                <div id="landingDispatchTree"></div>
                            </div>
                        </li>

                        <li class="big-menu ylzy-menu" v-show="isEnableLandingDispatch">
                            <a class="l-link">
                                <i class="menu-icon l-icon-ylzy"></i>
                                <span>运力资源</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu">
                                <div id="ylzyTree"></div>
                            </div>
                        </li>

                        <li class="big-menu zjb-menu" roleid="n1" v-show="isSuperRole">
                            <a class="l-link">
                                <i class="menu-icon l-icon-dygs"></i>
                                <span>定义公司</span>
                                <em class="l-icon-jiantou"></em>
                            </a>

                            <div class="child-menu xtsz-child-menu">
                                <div id="xtszTree-new"></div>
                            </div>
                        </li>
                    </ul>
                    <ul id="menuUl" v-else>
                        <li class="big-menu ylzy-menu" roleid="spuc001" v-if="hasSelfPickupPermission">
                            <a class="l-link-item l-link" data-tabid="spuc001" data-text="自助提货" data-url="/selfPickup/index">
                                <i class="menu-icon l-icon-dygs"></i>
                                <span>自助提货</span>
                            </a>
                        </li>
                        <li class="big-menu" roleid="floorMatch">
                            <a id="langing-router" data-tracktxt="落地配推荐" class="l-link-item l-link" data-tabid="179" data-text="落地配推荐" data-url="/newLqMall/langingDetail">
                                <i class="menu-icon l-icon-ylzy"></i>
                                <span>落地配推荐</span>
                                <em class="l-icon-jiantou"></em>
                                <div class="new-tips">新功能</div>
                            </a>
                        </li>
                        <li class="big-menu ylzy-menu" roleid="aitool" v-show="hasAIPermission">
                            <a class="l-link-item l-link" data-tabid="AIToolBoxIndex" data-text="AI工具箱" data-url="/AIToolBox/Index">
                                <i class="menu-icon l-icon-dygs"></i>
                                <span>AI工具箱</span>
                            </a>
                        </li>
                        <li class="big-menu ylzy-menu" v-show="isUserEnableOneCarKey">
                            <a class="l-link-item l-link" data-tabid="oneKeyCar" data-text="询价调车">
                                <i class="menu-icon l-icon-ylzy"></i>
                                <span>询价调车</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu xjdc-child-menu">
                                <div id="xjdcTree"></div>
                            </div>
                        </li>
                        <!-- 司机履约管理 -->
                        <li class="big-menu ylzy-menu" v-show="isEnableLandingDispatch">
                            <a class="l-link-item l-link" data-tabid="landingDispatch" data-text="司机履约">
                                <i class="menu-icon l-icon-ylzy"></i>
                                <span>司机履约</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu landing-child-menu">
                                <div id="landingDispatchTree"></div>
                            </div>
                        </li>
                        <li class="big-menu hasGoods" roleid="sylh">
                            <a class="l-link-item l-link" data-tabid="170" data-text="上游来货" data-url="/UpsteamOrder/index">
                                <i class="menu-icon l-icon-sylh"></i>
                                <span>上游来货</span>
                                <!-- <i id="UpSteamOrder" class="nums">0</i> -->
                            </a>
                        </li>

                        <!-- 包裹拼单定制菜单 -->
                        <li class="big-menu" id="sylh" v-show="showCombinePackage">
                            <a class="l-link">
                                <i class="menu-icon l-icon-ylzy"></i>
                                <span>包裹拼单</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu zjzh-child-menu">
                                <div id="Tree_bgpd"></div>
                            </div>
                        </li>

                        <li class="big-menu yyzx-menu white-list-module" roleid="a1">
                            <a class="l-link">
                                <i class="menu-icon l-icon-yyzx"></i>
                                <span>营运中心</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="has-adv-content shell-menu flowChart yyzxflowChart">
                                <div>
                                    <div class="center-container">
                                        <ul class="center-container-ul">
                                        <div class="tuding" onclick="openflowChart('yyzxflowChart',this,'isJava')"></div>
                                        <div
                                            style="
                                                background: url(https://imagecdn.ymm56.com/ymmfile/static/resource/yyCenter-蓝桥箭头2.png);
                                                background-size: 100% 100%;
                                                height: 536px;
                                                width: 600px;
                                                margin-left: 101px;
                                                margin-top: 85px;
                                                margin-right: 20px;
                                            "
                                            id="yyzxflowChart-bg"
                                        >
                                            <div
                                                style="
                                                    background: url(https://imagecdn.ymm56.com/ymmfile/static/resource/yyCenter-xuxian.png);
                                                    background-size: 100% 100%;
                                                    height: 208px;
                                                    width: 28px;
                                                    opacity: 0.5;
                                                    position: absolute;
                                                    left: 260px;
                                                    top: 313px;
                                                    display: none;
                                                "
                                                class="isytpz_show"
                                            ></div>
                                        </div>
                                        <!-- <li class="greenline"></li> -->

                                        <li class="small-menu list01 item-menu has-mini-menu" roleid="a117">
                                            <a
                                                class="l-link-item"
                                                data-tabid="1"
                                                data-text="网络订单"
                                                data-url="/WebOrder/index"
                                                data-trackid="网络订单"
                                            >
                                                <i class="l-menu-icon l-icon l-icon-wangluodingdan"></i>
                                                <span>网络订单</span>
                                            </a>
                                        </li>

                                        <li class="small-menu list01 kpcd item-menu has-mini-menu" roleid="a12">
                                            <a
                                                class="l-link-item"
                                                data-tabid="2"
                                                :data-text="kpcdTitle"
                                                data-url="/OutgoingRegistration/PollingTable"
                                                data-trackid="开派车单"
                                            >
                                                <i class="l-menu-icon l-icon l-icon-kaipaichedan"></i>
                                                <span>{{ kpcdTitle }}</span>
                                            </a>
                                        </li>

                                        <li class="small-menu list02 slkd item-menu has-mini-menu" roleid="a13">
                                            <a
                                                class="l-link-item"
                                                data-tabid="4"
                                                data-text="受理开单"
                                                data-url="/AcceptanceOfBill/index"
                                                data-trackid="受理开单"
                                            >
                                                <i class="l-menu-icon l-icon l-icon-shoulikaidan"></i>
                                                <span>受理开单</span>
                                            </a>
                                        </li>

                                        <li class="small-menu list02 dtjb item-menu has-mini-menu" roleid="a17">
                                            <template v-if="tmscode === '82380'">
                                                <a class="l-link-item" data-tabid="3" data-text="分拨运单" data-url="/ShortHauls/ShortHaulConnection">
                                                    <i class="l-menu-icon l-icon l-icon-duantujiebo"></i>
                                                    <span>分拨运单</span>
                                                </a>
                                            </template>
                                            <template v-else>
                                                <a
                                                    class="l-link-item"
                                                    data-tabid="3"
                                                    data-text="短途接驳"
                                                    data-url="/ShortHauls/ShortHaulConnection"
                                                    data-trackid="短途接驳"
                                                >
                                                    <i class="l-menu-icon l-icon l-icon-duantujiebo"></i>
                                                    <span>短途接驳</span>
                                                </a>
                                            </template>
                                        </li>

                                        <li class="small-menu list03 fhkc item-menu" roleid="a14">
                                            <a class="l-link-item" data-tabid="5" data-text="发货库存" data-url="/fhkc/index" data-trackid="发货库存">
                                                <i class="l-menu-icon l-icon l-icon-fahuokucun"></i>
                                                <span>发货库存</span>
                                            </a>
                                        </li>

                                        <li v-if="getCustomizedConfigByKey('is_group_mode')" class="small-menu list03 pdkc item-menu" roleid="a118" style="left:253px;top:126px;">
                                            <a class="l-link-item" data-tabid="fhkc_pdkc" data-text="拼单库存" data-url="/fhkc/pdkc" data-trackid="拼单库存">
                                                <i class="l-menu-icon l-icon l-icon-fahuokucun"></i>
                                                <span>拼单库存</span>
                                            </a>
                                        </li>

                                        <li class="small-menu list03 isfdpz fdpz item-menu has-mini-menu" roleid="a18">
                                            <a class="l-link-item" data-tabid="6" data-text="分单配载" data-url="/fdpz/index" data-trackid="分单配载">
                                                <i class="l-menu-icon l-icon l-icon-fendanpeizai"></i>
                                                <span>分单配载</span>
                                            </a>
                                        </li>

                                        <li class="small-menu list04 bddl item-menu has-mini-menu" roleid="a15">
                                            <a
                                                class="l-link-item"
                                                data-tabid="8"
                                                data-text="本地代理"
                                                data-url="/OutgoingRegistration/HomeAgent?ingettype=0"
                                                data-trackid="本地代理"
                                            >
                                                <i class="l-menu-icon l-icon l-icon-bendidaili"></i>
                                                <span>本地代理</span>
                                            </a>
                                        </li>

                                        <li class="small-menu list04 eczz item-menu has-mini-menu" roleid="a1516" style="left: 337px; top:4px" v-show="enableSecondaryTransfer">
                                            <a
                                                class="l-link-item"
                                                data-tabid="secondary_transfer"
                                                data-text="二次中转记录"
                                                data-url="/OutgoingRegistration/HomeAgent?ingettype=0&isSecondaryTransfer=1"
                                                data-trackid="二次中转"
                                            >
                                                <i class="l-menu-icon l-icon l-icon-bendidaili"></i>
                                                <span>二次中转</span>
                                            </a>
                                            <img style="position:absolute;right: 17px;top:62px;width:26px;height:auto;transform: rotateX(180deg);"  src="https://imagecdn.ymm56.com/ymmfile/static/resource/569bee6d-2511-4f01-9141-179be1988256.png" alt="" srcset="">
                                        </li>

                                        <li class="small-menu list04 clgz item-menu" roleid="a19">
                                            <template v-if="tmscode === '90021'">
                                                <a
                                                    class="l-link-item"
                                                    data-tabid="7"
                                                    data-text="货物跟踪"
                                                    data-url="/TrackingInTransit/OutsourcedGoods?types=clgz"
                                                >
                                                    <i class="l-menu-icon l-icon l-icon-chelianggenzong"></i>
                                                    <span>货物跟踪</span>
                                                </a>
                                            </template>
                                            <template v-else>
                                                <a
                                                    class="l-link-item"
                                                    data-tabid="7"
                                                    data-text="车辆跟踪"
                                                    data-url="/ztgz/index"
                                                    data-trackid="车辆跟踪"
                                                >
                                                    <i class="l-menu-icon l-icon l-icon-chelianggenzong"></i>
                                                    <span>车辆跟踪</span>
                                                </a>
                                            </template>
                                        </li>

                                        <!-- 落地配配载 -->
                                        <li class="small-menu list03 ldppz item-menu has-mini-menu" roleid="a18" style="left: 28px !important; top:390px" v-show="isEnableLandingStowage">
                                            <a
                                                class="l-link-item"
                                                data-tabid="landing_stowage"
                                                data-text="落地配载"
                                                data-url="/fdpz/index?fromScene=landingStowage"
                                                data-trackid="落地配载"
                                            >
                                                <i class="l-menu-icon l-icon l-icon-fendanpeizai"></i>
                                                <span>落地配载</span>
                                            </a>
                                            <img style="position:absolute;right: -98px;top:21px;width:82px;height:14px;"  src="https://imagecdn.ymm56.com/ymmfile/static/resource/3b6aa13d-9887-4618-8526-967730d0e10b.jpg" alt="" srcset="">
                                        </li>

                                        <li
                                            class="small-menu list04 clgz item-menu"
                                            roleid="a19"
                                            style="left: 340px !important; top: 333px"
                                            v-if="tmscode === '82380'"
                                        >
                                            <a
                                                class="l-link-item"
                                                data-tabid="7_80831"
                                                data-text="拨入接受"
                                                data-url="/ShortHauls/ShortHaulConnection?opentype82380=接受"
                                            >
                                                <i class="l-menu-icon l-icon l-icon-duantujiebo"></i>
                                                <span>拨入接受</span>
                                            </a>
                                        </li>

                                        <li class="small-menu list03 hwgz item-menu" roleid="a16">
                                            <a
                                                class="l-link-item"
                                                data-tabid="9"
                                                data-text="货物跟踪"
                                                data-url="/TrackingInTransit/OutsourcedGoods?types=hwgz"
                                                data-trackid="货物跟踪"
                                            >
                                                <i class="l-menu-icon l-icon l-icon-huowugenzong"></i>
                                                <span>货物跟踪</span>
                                            </a>
                                        </li>

                                        <li class="small-menu list03 dhqr item-menu" roleid="a111">
                                            <a
                                                class="l-link-item"
                                                data-tabid="10"
                                                data-text="到货确认"
                                                data-url="/dhqr/index"
                                                data-trackid="到货确认"
                                            >
                                                <i class="l-menu-icon l-icon l-icon-daohuoqueren"></i>
                                                <span>到货确认</span>
                                            </a>
                                        </li>

                                        <li class="small-menu list03 dhkc item-menu" roleid="a112">
                                            <a
                                                class="l-link-item"
                                                data-tabid="11"
                                                data-text="到货库存"
                                                data-url="/ArrivalInventory/index"
                                                data-trackid="到货库存"
                                            >
                                                <i class="l-menu-icon l-icon l-icon-daohuokucun"></i>
                                                <span>到货库存</span>
                                            </a>
                                        </li>

                                        <li class="small-menu list02 khth item-menu has-mini-menu" roleid="a113">
                                            <a
                                                class="l-link-item"
                                                data-tabid="12"
                                                data-text="客户提货"
                                                data-url="/CustomerPickUp/index"
                                                data-trackid="客户提货"
                                            >
                                                <i class="l-menu-icon l-icon l-icon-kehutihuo"></i>
                                                <span>客户提货</span>
                                            </a>
                                        </li>

                                        <li class="small-menu list02 shsm item-menu has-mini-menu" roleid="a114">
                                            <a
                                                class="l-link-item"
                                                data-tabid="14"
                                                data-text="送货上门"
                                                data-url="/DeliveryRecord/index"
                                                data-trackid="送货上门"
                                            >
                                                <i class="l-menu-icon l-icon l-icon-songhuoshangmen"></i>
                                                <span>送货上门</span>
                                            </a>
                                        </li>

                                        <li class="small-menu list02 zddl item-menu has-mini-menu" roleid="a115">
                                            <a
                                                class="l-link-item"
                                                data-tabid="15"
                                                data-text="终端代理"
                                                data-url="/OutgoingRegistration/HomeAgent?ingettype=1"
                                                data-trackid="终端代理"
                                            >
                                                <i class="l-menu-icon l-icon l-icon-zhongduandaili"></i>
                                                <span>终端代理</span>
                                            </a>
                                        </li>
                                        <!-- 出库登记 -->
                                        <li class="small-menu list03 ldppz item-menu has-mini-menu" roleid="ckRegister_index" style="left: 610px; top:390px" v-show="isEnableLandingStowage">
                                            <a
                                                class="l-link-item"
                                                data-tabid="ckRegister_index"
                                                data-text="出库登记"
                                                data-url="/ckRegister/index"
                                                data-trackid="出库登记"
                                            >
                                                <i class="l-menu-icon l-icon l-icon-fendanpeizai"></i>
                                                <span>出库登记</span>
                                            </a>
                                            <img style="position:absolute;right: 17px;top:62px;width:26px;height:auto;"  src="https://imagecdn.ymm56.com/ymmfile/static/resource/569bee6d-2511-4f01-9141-179be1988256.png" alt="" srcset="">
                                        </li>
                                        <li class="small-menu list02 shqs item-menu has-mini-menu" roleid="a116">
                                            <a
                                                class="l-link-item"
                                                data-tabid="16"
                                                data-text="签收登记"
                                                data-url="/qsRegister/Index"
                                                data-trackid="签收登记"
                                            >
                                                <i class="l-menu-icon l-icon l-icon-songhuoqianshou"></i>
                                                <span>签收登记</span>
                                            </a>
                                        </li>

                                        <li class="small-menu list04 ycdj item-menu" roleid="a110">
                                            <a class="l-link-item" onclick="openyc('mergeAll', 'fromHome')">
                                                <i class="l-menu-icon l-icon l-icon-yichangdengji"></i>
                                                <span>异常登记</span>
                                            </a>
                                            <div class="ycdj-small-menu" v-if="tmscode !== '97993'">
                                                <a
                                                    class="l-link-item"
                                                    roleid="a11001"
                                                    onclick="openyc('wenti', 'fromHome')"
                                                    title="问题件上报"
                                                    data-trackid="问题件上报"
                                                >
                                                    <i class="l-icon-wentijian"></i>
                                                    <span>问题件上报</span>
                                                </a>
                                                <a
                                                    class="l-link-item"
                                                    roleid="a11002"
                                                    onclick="openyc('wutou', 'fromHome')"
                                                    title="无头件上报"
                                                    data-trackid="无头件上报"
                                                >
                                                    <i class="l-icon-wutoujian"></i>
                                                    <span>无头件上报</span>
                                                </a>
                                                <a
                                                    class="l-link-item"
                                                    roleid="a11003"
                                                    onclick="openyc('qihuo', 'fromHome')"
                                                    title="弃货上报"
                                                    data-trackid="弃货上报"
                                                >
                                                    <i class="l-icon-qijian"></i>
                                                    <span>弃货上报</span>
                                                </a>
                                                <a
                                                    class="l-link-item"
                                                    roleid="a11004"
                                                    onclick="openyc('lipei', 'fromHome')"
                                                    title="理赔申请"
                                                    data-trackid="理赔申请"
                                                >
                                                    <i class="l-icon-lipei"></i>
                                                    <span>理赔申请</span>
                                                </a>
                                            </div>
                                        </li>
                                        </ul>
                                    </div>
                                </div>

                                <iframe
                                    class="hideiframe"
                                    src="about:blank"
                                    frameborder="0"
                                    marginheight="0"
                                    marginwidth="0"
                                    style="
                                        position: absolute;
                                        visibility: inherit;
                                        top: 0px;
                                        left: 0px;
                                        width: 100%;
                                        height: 100%;
                                        z-index: -1;
                                        filter: alpha(opacity=0);
                                    "
                                ></iframe>
                            </div>
                        </li>

                        <li class="big-menu" roleid="zckp1" id="manyunbao" style="display: none">
                            <a class="l-link">
                                <i class="menu-icon l-icon-ylzy"></i>
                                <span>找车开票</span>
                                <em class="l-icon-jiantou"></em>
                                <!-- <div class="new-tips">新功能</div> -->
                            </a>
                            <div class="child-menu zjzh-child-menu">
                                <div id="manyunbao-tree"></div>
                            </div>
                            <div class="shell-menu flowChart mybflowChart">
                                <div class="tuding" onclick="openflowChart('mybflowChart',this)"></div>
                                <div
                                    style="
                                        background-image: url(https://imagecdn.ymm56.com/ymmfile/static/resource/myb-img-bg_line.png);
                                        background-size: 100% auto;
                                        background-repeat: no-repeat;
                                        background-position: center;
                                        height: 100%;
                                        width: 90%;
                                    "
                                    id="mybflowChart-bg"
                                ></div>
                                <ul>
                                    <!-- 找车入口图标 -->
                                    <li class="small-menu item-menu item-menu-zc small-menu-01 has-mini-menu" roleid="zckp11">
                                        <a
                                            class="l-link-item"
                                            onclick="openHDGL('myb-tab-id-01','发布找车','/MybSupplyManagement/PzFindCarList?opentype=发布找车&listtype=找车')"
                                            data-text="发布找车"
                                        >
                                            <i class="l-menu-icon l-icon l-icon-icon_fabuzhaoche1"></i>
                                            <span>发布找车</span>
                                        </a>
                                    </li>
                                    <li class="small-menu item-menu item-menu-zc small-menu-02" roleid="zckp12">
                                        <a
                                            class="l-link-item"
                                            onclick="openHDGL('myb-tab-id-02','签订协议-找车','/MybSupplyManagement/PzFindCarList?opentype=签订协议&listtype=找车')"
                                        >
                                            <i class="l-menu-icon l-icon l-icon-icon_qiandingxieyi1"></i>
                                            <span>签订协议</span>
                                        </a>
                                    </li>
                                    <li class="small-menu item-menu item-menu-zc small-menu-03" roleid="zckp13">
                                        <a
                                            class="l-link-item"
                                            onclick="openHDGL('myb-tab-id-03','分单配载-找车','/MybSupplyManagement/PzFindCarList?opentype=分单配载&listtype=找车')"
                                        >
                                            <i class="l-menu-icon l-icon l-icon-icon_fendanpeizai1"></i>
                                            <span>分单配载</span>
                                        </a>
                                    </li>
                                    <li class="small-menu item-menu item-menu-zc small-menu-04" roleid="zckp14">
                                        <a
                                            class="l-link-item"
                                            onclick="openHDGL('myb-tab-id-04','送货上门-找车','/MybSupplyManagement/PzFindCarList?opentype=送货上门&listtype=找车')"
                                        >
                                            <i class="l-menu-icon l-icon l-icon-icon_songhuoshangmen"></i>
                                            <span>送货上门</span>
                                        </a>
                                    </li>
                                    <!-- 熟车入口图标 -->
                                    <li class="small-menu item-menu item-menu-sc small-menu-05 has-mini-menu" roleid="a18">
                                        <a class="l-link-item" data-tabid="6" data-text="分单配载" data-url="/fdpz/index" data-trackid="分单配载">
                                            <i class="l-menu-icon l-icon l-icon-icon_fendanpeizai1"></i>
                                            <span>分单配载</span>
                                        </a>
                                    </li>
                                    <li class="small-menu item-menu item-menu-sc small-menu-06" roleid="zckp16">
                                        <a class="l-link-item" data-tabid="14" data-text="送货上门" data-url="/DeliveryRecord/index">
                                            <i class="l-menu-icon l-icon l-icon-icon_songhuoshangmen"></i>
                                            <span>送货上门</span>
                                        </a>
                                    </li>
                                    <li class="small-menu item-menu item-menu-sc small-menu-07" roleid="zckp17">
                                        <a
                                            class="l-link-item"
                                            onclick="openHDGL('myb-tab-id-05','签订协议-熟车','/MybSupplyManagement/PzFindCarList?opentype=签订协议&listtype=熟车')"
                                        >
                                            <i class="l-menu-icon l-icon l-icon-icon_qiandingxieyi1"></i>
                                            <span>签订协议</span>
                                        </a>
                                    </li>
                                    <!-- 共享图标 -->
                                    <li class="small-menu item-menu item-menu-gx small-menu-08" roleid="zckp18">
                                        <a
                                            class="l-link-item"
                                            onclick="openHDGL('myb-tab-id-08','车辆跟踪','/MybSupplyManagement/PzFindCarList?opentype=车辆跟踪')"
                                        >
                                            <i class="l-menu-icon l-icon l-icon-icon_chelianggenzong1"></i>
                                            <span>车辆跟踪</span>
                                        </a>
                                    </li>
                                    <li class="small-menu item-menu item-menu-gx small-menu-09" roleid="zckp19">
                                        <a
                                            class="l-link-item"
                                            onclick="openHDGL('myb-tab-id-09','履约装货','/MybSupplyManagement/PzFindCarList?opentype=履约装货')"
                                        >
                                            <i class="l-menu-icon l-icon l-icon-icon_lvyuezhuanghuo"></i>
                                            <span>履约装货</span>
                                        </a>
                                    </li>
                                    <li class="small-menu item-menu item-menu-gx small-menu-10" roleid="zckp110">
                                        <a
                                            class="l-link-item"
                                            onclick="openHDGL('myb-tab-id-10','履约装货','/MybSupplyManagement/PzFindCarList?opentype=履约卸货')"
                                        >
                                            <i class="l-menu-icon l-icon l-icon-icon_lvyuexiehuo1"></i>
                                            <span>履约卸货</span>
                                        </a>
                                    </li>
                                    <li class="small-menu item-menu item-menu-gx small-menu-11" roleid="zckp111">
                                        <a
                                            class="l-link-item"
                                            onclick="openHDGL('myb-tab-id-11','回单上传','/MybSupplyManagement/PzFindCarList?opentype=回单上传')"
                                        >
                                            <i class="l-menu-icon l-icon l-icon-icon_huidanshangchuan"></i>
                                            <span>回单上传</span>
                                        </a>
                                    </li>
                                    <li class="small-menu item-menu item-menu-gx small-menu-12" roleid="zckp112">
                                        <a
                                            class="l-link-item"
                                            onclick="openHDGL('myb-tab-id-12','支付运费','/MybSupplyManagement/PzFindCarList?opentype=支付运费')"
                                        >
                                            <i class="l-menu-icon l-icon l-icon-icon_zhifuyunfei"></i>
                                            <span>支付运费</span>
                                        </a>
                                    </li>
                                    <li class="small-menu item-menu item-menu-gx small-menu-13" roleid="zckp113">
                                        <a class="l-link-item" data-tabid="myb-tab-id-13" data-text="订单开票" data-url>
                                            <i class="l-menu-icon l-icon l-icon-icon_dingdankaipiao1"></i>
                                            <span>订单开票</span>
                                        </a>
                                    </li>
                                </ul>
                                <iframe
                                    class="hideiframe"
                                    src="about:blank"
                                    frameborder="0"
                                    marginheight="0"
                                    marginwidth="0"
                                    style="
                                        position: absolute;
                                        visibility: inherit;
                                        top: 0px;
                                        left: 0px;
                                        width: 100%;
                                        height: 100%;
                                        z-index: -1;
                                        filter: alpha(opacity=0);
                                    "
                                ></iframe>
                            </div>
                        </li>
                        <template v-if="tmscode === '80935'">
                            <li class="big-menu wttx-menu" roleid>
                                <a class="l-link">
                                    <i class="menu-icon l-icon-wttx"></i>
                                    <span>寄存管理</span>
                                    <em class="l-icon-jiantou"></em>
                                </a>
                                <div class="child-menu">
                                    <ul>
                                        <li roleid>
                                            <a class="l-link-item" data-tabid="8121" data-text="寄存记录" data-url="/Deposit/Index">
                                                <span class="child-span">寄存记录</span>
                                            </a>
                                        </li>
                                        <li roleid>
                                            <a class="l-link-item" data-tabid="8122" data-text="寄存提货记录" data-url="/Deposit/FetchDeposit">
                                                <span class="child-span">寄存提货</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </template>
                        <li class="big-menu ylzy-menu" roleid id="kdcrc" style="display: none">
                            <a class="l-link">
                                <i class="menu-icon l-icon-cangchu"></i>
                                <span>快递出入仓</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu">
                                <div id="kdcrcTree"></div>
                            </div>
                        </li>

                        <li class="big-menu lbzx-menu" roleid="b1">
                            <a class="l-link">
                                <i class="menu-icon l-icon-hdgl"></i>
                                <span>回单管理</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="has-adv-content shell-menu flowChart hdglflowChart" style="max-height: 880px">
                                <div class="center-container">
                                    <ul class="center-container-ul">
                                        <div class="tuding" onclick="openflowChart('hdglflowChart',this)"></div>
                                        <div
                                            style="
                                                background: url(https://imagecdn.ymm56.com/ymmfile/static/resource/7713907c-9736-4a0b-aa5f-4ecd58dab0b5.png) no-repeat;
                                                height: 507px;
                                                width: 506px;
                                                margin-left: 54px;
                                                margin-top: 50px;
                                            "
                                        ></div>
                                        <!-- <li class="greenline"></li> -->
                                        <li class="small-menu list01 item-menu" roleid="b11" style="left: 160px; top: 84px">
                                            <a class="l-link-item" onclick="openHDGL(22,'回单签收','/SignTheReceipt/Index?1')">
                                                <i class="l-menu-icon l-icon l-icon-huidanqianshou"></i>
                                                <span>回单签收</span>
                                            </a>
                                        </li>

                                        <li class="small-menu list01 jhdj item-menu" roleid="b12" style="top: 84px; left: 304px">
                                            <a class="l-link-item" onclick="openHDGL(23,'回单寄出','/SendTheReceipt/Index?2')">
                                                <i class="l-menu-icon l-icon l-icon-huidanjichu"></i>
                                                <span>回单寄出</span>
                                            </a>
                                        </li>

                                        <li class="small-menu list01 kpcd item-menu" roleid="b13" style="left: 304px; top: 234px">
                                            <a class="l-link-item" onclick="openHDGL(24,'回单收到','/SignBack/index')">
                                                <i class="l-menu-icon l-icon l-icon-huidanshoudao"></i>
                                                <span>回单收到</span>
                                            </a>
                                        </li>

                                        <li class="small-menu list01 smth item-menu" roleid="b14" style="top: 374px; left: 304px">
                                            <a class="l-link-item" onclick="openHDGL(25,'回单返厂','/SingleDepot/index?4')">
                                                <i class="l-menu-icon l-icon l-icon-huidanfanchang"></i>
                                                <span>回单返厂</span>
                                            </a>
                                        </li>
                                        <li class="small-menu list01 hdzb item-menu" roleid="b15" style="left: 160px; top: 374px">
                                            <a
                                                class="l-link-item"
                                                roleid="b15"
                                                data-tabid="122"
                                                data-text="回单总账"
                                                data-url="/ReportTpl/Index"
                                                gridid="20e6bf9b-e49e-2c15-2d43-306c01f74fa8"
                                                data-type="report"
                                                data-view-type="回单总账报表"
                                                data-filter="16,4,5,6,7"
                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                            >
                                                <i class="l-menu-icon l-icon l-icon-huidanzongbiao"></i>
                                                <span>回单总账</span>
                                            </a>
                                        </li>

                                        <div class="bbmk">
                                            <div class="bb">
                                                <ul>
                                                    <li>报表</li>
                                                    <li roleid="b1602">
                                                        <a
                                                            class="l-link-item item-menu-right"
                                                            roleid="b1602"
                                                            data-tabid="123"
                                                            data-text="未签回单日报表"
                                                            data-url="/ReportTpl/Index"
                                                            gridid="838dce3d-048d-b3ab-0fc3-ccc01acf928f"
                                                            data-type="report"
                                                            data-view-type="未签回单日报表"
                                                            data-unsite="true"
                                                            data-filter="4,5,6,7"
                                                            data-ajax-url="/ReportTpl/GetDataCommon"
                                                        >
                                                            未签回单日报表
                                                        </a>
                                                    </li>
                                                    <li roleid="b1603">
                                                        <a
                                                            class="l-link-item item-menu-right"
                                                            roleid="b1603"
                                                            data-tabid="124"
                                                            data-text="未寄回单日报表"
                                                            data-url="/ReportTpl/Index"
                                                            gridid="acfdddfd-d73b-5bfe-f8d3-78dad5157f53"
                                                            data-type="report"
                                                            data-view-type="未寄回单日报表"
                                                            data-unsite="true"
                                                            data-filter="4,5,6,7"
                                                            data-ajax-url="/ReportTpl/GetDataCommon"
                                                        >
                                                            未寄回单日报表
                                                        </a>
                                                    </li>
                                                    <li roleid="b1604">
                                                        <a
                                                            class="l-link-item item-menu-right"
                                                            roleid="b1604"
                                                            data-tabid="125"
                                                            data-text="未回回单日报表"
                                                            data-url="/ReportTpl/Index"
                                                            gridid="2e0d127a-4574-5d8a-5f00-e7ecf9bb32c0"
                                                            data-type="report"
                                                            data-filter="4,5,6,7"
                                                            data-view-type="未回回单日报表"
                                                            data-ajax-url="/ReportTpl/GetDataCommon"
                                                        >
                                                            未回回单日报表
                                                        </a>
                                                    </li>
                                                    <li roleid="b1605">
                                                        <a
                                                            class="l-link-item item-menu-right"
                                                            roleid="b1605"
                                                            data-tabid="126"
                                                            data-text="未返回单日报表"
                                                            data-url="/ReportTpl/Index"
                                                            gridid="cfaa18ad-588b-8c0a-4957-37a58043ade3"
                                                            data-type="report"
                                                            data-filter="4,5,6,7"
                                                            data-view-type="未返回单日报表"
                                                            data-ajax-url="/ReportTpl/GetDataCommon"
                                                        >
                                                            未返回单日报表
                                                        </a>
                                                    </li>

                                                    <li roleid="b1608">
                                                        <a
                                                            class="l-link-item item-menu-right"
                                                            roleid="b1608"
                                                            data-tabid="261"
                                                            data-text="回单签收日报表"
                                                            data-url="/ReportTpl/Index"
                                                            gridid="cf98b73a-09c2-7d54-1756-b97211b234a4"
                                                            data-type="report"
                                                            data-filter="30,4,5,6,7"
                                                            data-view-type="回单签收日报表"
                                                            data-ajax-url="/ReportTpl/GetDataCommon"
                                                        >
                                                            回单签收日报表
                                                        </a>
                                                    </li>

                                                    <li roleid="b1606">
                                                        <a
                                                            class="l-link-item item-menu-right"
                                                            roleid="b1606"
                                                            data-tabid="139"
                                                            data-text="回单寄出日报表"
                                                            data-url="/ReportTpl/Index"
                                                            gridid="2b7965f8-f5a1-e8a7-15b6-6174d9c016b3"
                                                            data-type="report"
                                                            data-filter="30,4,5,6,7"
                                                            data-view-type="回单寄出日报表"
                                                            data-ajax-url="/ReportTpl/GetDataCommon"
                                                        >
                                                            回单寄出日报表
                                                        </a>
                                                    </li>

                                                    <li roleid="b1609">
                                                        <a
                                                            class="l-link-item item-menu-right"
                                                            roleid="b1609"
                                                            data-tabid="262"
                                                            data-text="回单返回日报表"
                                                            data-url="/ReportTpl/Index"
                                                            gridid="c057b6a5-8a1a-066b-f1fd-85957eff2eb1"
                                                            data-type="report"
                                                            data-view-type="回单返回日报表"
                                                            data-unsite="true"
                                                            data-filter="30,4,5,6,7"
                                                            data-ajax-url="/ReportTpl/GetDataCommon"
                                                        >
                                                            回单返回日报表
                                                        </a>
                                                    </li>

                                                    <li roleid="b1607">
                                                        <a
                                                            class="l-link-item item-menu-right"
                                                            roleid="b1607"
                                                            data-tabid="121"
                                                            data-text="回单返厂日报表"
                                                            data-url="/ReportTpl/Index"
                                                            gridid="1724a29d-a977-157f-de55-2c7be37df6c5"
                                                            data-type="report"
                                                            data-filter="30,4,5,6,7"
                                                            data-view-type="回单返厂日报表"
                                                            data-ajax-url="/ReportTpl/GetDataCommon"
                                                        >
                                                            回单返厂日报表
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="bgcz">
                                                <ul>
                                                    <li>变更操作</li>
                                                    <li roleid="b1701">
                                                        <a class="l-link-item item-menu-right" onclick="openHDhandle('反签收',0)">反签收</a>
                                                    </li>
                                                    <li roleid="b1702">
                                                        <a class="l-link-item item-menu-right" onclick="openHDhandle('反寄出',1)">反寄出</a>
                                                    </li>
                                                    <li roleid="b1703">
                                                        <a class="l-link-item item-menu-right" onclick="openHDhandle('反收回',2)">反收回</a>
                                                    </li>
                                                    <li roleid="b1704">
                                                        <a class="l-link-item item-menu-right" onclick="openHDhandle('取消返厂',3)">取消返厂</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </li>

                        <li class="big-menu cwzx-menu" roleid="c1">
                            <a class="l-link">
                                <i class="menu-icon l-icon-cwzx"></i>
                                <span>财务中心</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div style="border-top: none;maxWidth: 1220px;" class="financial-menu-content shell-menu flowChart cwzxflowChart">
                                <div class="center-container">
                                    <ul class="shell-menu-ul financial-menu-ul" style="border-top: 8px solid #1d3b77;">
                                        <li class="small-menu cw-samll-title small-menu-cur white-list-module" roleid="c11">
                                            <a class="main-menu-bar" data-tracktxt="财务做账">
                                                <span class="cw-center-li-span">财务做账</span>
                                            </a>
                                            <div id="min-menu-cwzz" class="min-menu kxglMenu" style="left: 50px;margin-top:-20px;">
                                                <div
                                                    style="
                                                        background: url(https://imagecdn.ymm56.com/ymmfile/static/resource/99863fb8-5905-4ab4-9396-d9a40b43dab3.png);
                                                        background-size: 100% 100%;
                                                        height: 470px;
                                                        width: 755px;
                                                        margin-left: 0;
                                                        margin-top: -5px;
                                                    "
                                                ></div>
                                                <div
                                                    roleid="c1101"
                                                    class="item-menu"
                                                    style="width: 90px; height: 50px; position: absolute; top: 204px; left: 55px; color: #000"
                                                >
                                                    <a
                                                        style="color: #000; height: 40px; width: 100%"
                                                        class="l-link-item"
                                                        onclick="opencw(this,'isJava', '管理费用请款')"
                                                        lrtype="2-add"
                                                    >
                                                        <i class="l-menu-icon l-icon l-icon-yunfeihexiao"></i>
                                                        <span
                                                            style="
                                                                width: 100%;
                                                                height: 20px;
                                                                display: inline-block;
                                                                line-height: 20px;
                                                                text-indent: 0px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            管理费用请款
                                                        </span>
                                                    </a>
                                                </div>
                                                <div
                                                    roleid="c1102"
                                                    class="item-menu"
                                                    style="width: 92px; height: 60px; position: absolute; top: 282px; left: 55px; color: #000"
                                                >
                                                    <a
                                                        style="color: #000; height: 40px; width: 100%"
                                                        class="l-link-item"
                                                        onclick="openMoreTab('业务支出请款')"
                                                    >
                                                        <i class="l-menu-icon l-icon l-icon-fushicaiwu"></i>
                                                        <span
                                                            style="
                                                                width: 100%;
                                                                height: 20px;
                                                                display: inline-block;
                                                                line-height: 20px;
                                                                text-indent: 0px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            业务支出请款
                                                        </span>
                                                    </a>
                                                </div>
                                                <div
                                                    roleid="c1105"
                                                    class="item-menu"
                                                    style="width: 70px; height: 60px; position: absolute; top: 118px; left: 55px; color: #000"
                                                >
                                                    <a
                                                        style="color: #000; height: 40px; width: 100%"
                                                        class="l-link-item"
                                                        onclick="opencw(this,'isJava','现金录入')"
                                                        lrtype="0-add"
                                                    >
                                                        <i class="l-menu-icon l-icon l-icon-fushicaiwu"></i>
                                                        <span
                                                            style="
                                                                width: 100%;
                                                                height: 20px;
                                                                display: inline-block;
                                                                line-height: 20px;
                                                                text-indent: 0px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            现金录入
                                                        </span>
                                                    </a>
                                                </div>
                                                <div
                                                    roleid="c1106"
                                                    class="item-menu"
                                                    style="width: 90px; height: 60px; position: absolute; top: 118px; left: 207px; color: #000"
                                                >
                                                    <a
                                                        style="color: #000; height: 40px; width: 100%"
                                                        class="l-link-item"
                                                        onclick="opencw(this,'isJava','银行存款录入')"
                                                        lrtype="1-add"
                                                    >
                                                        <i class="l-menu-icon l-icon l-icon-fushicaiwu"></i>
                                                        <span
                                                            style="
                                                                width: 100%;
                                                                height: 20px;
                                                                display: inline-block;
                                                                line-height: 20px;
                                                                text-indent: 0px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            银行存款录入
                                                        </span>
                                                    </a>
                                                </div>
                                                <div
                                                    roleid="c1108"
                                                    class="item-menu"
                                                    style="width: 70px; height: 60px; position: absolute; top: 37px; left: 207px; color: #000"
                                                >
                                                    <a
                                                        style="color: #000; height: 40px; width: 100%"
                                                        class="l-link-item"
                                                        onclick="openMoreTab('核销明细')"
                                                    >
                                                        <i class="l-menu-icon l-icon l-icon-fushicaiwu"></i>
                                                        <span
                                                            style="
                                                                width: 100%;
                                                                height: 20px;
                                                                display: inline-block;
                                                                line-height: 20px;
                                                                text-indent: 0px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            核销明细
                                                        </span>
                                                    </a>
                                                </div>
                                                <div
                                                    roleid="c1107"
                                                    class="item-menu"
                                                    style="width: 70px; height: 60px; position: absolute; top: 37px; left: 55px; color: #000"
                                                >
                                                    <a
                                                        style="color: #000; height: 40px; width: 100%"
                                                        class="l-link-item"
                                                        onclick="openMoreTab('结款核销')"
                                                    >
                                                        <i class="l-menu-icon l-icon l-icon-fushicaiwu"></i>
                                                        <span
                                                            style="
                                                                width: 100%;
                                                                height: 20px;
                                                                display: inline-block;
                                                                line-height: 20px;
                                                                text-indent: 0px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            结款核销
                                                        </span>
                                                    </a>
                                                </div>
                                                <div
                                                    roleid="c1103"
                                                    class="item-menu"
                                                    style="width: 70px; height: 60px; position: absolute; top: 242px; left: 207px; color: #000"
                                                >
                                                    <a
                                                        style="color: #000; height: 40px; width: 100%"
                                                        class="l-link-item"
                                                        data-tabid="416"
                                                        data-text="请款审批"
                                                        data-url="/PleaseInquire/PleaseReview"
                                                        data-tracktxt="请款审批"
                                                    >
                                                        <i class="l-menu-icon l-icon l-icon-fushicaiwu"></i>
                                                        <span
                                                            style="
                                                                width: 100%;
                                                                height: 20px;
                                                                display: inline-block;
                                                                line-height: 20px;
                                                                text-indent: 0px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            请款审批
                                                        </span>
                                                    </a>
                                                </div>
                                                <div
                                                    roleid="c1104"
                                                    class="item-menu"
                                                    style="width: 70px; height: 60px; position: absolute; top: 242px; left: 327px; color: #000"
                                                >
                                                    <a
                                                        style="color: #000; height: 40px; width: 100%"
                                                        class="l-link-item"
                                                        data-tabid="417"
                                                        data-text="请款结果"
                                                        data-url="/PleaseInquire/PleaseInquire_Index"
                                                        data-tracktxt="请款结果"
                                                    >
                                                        <i class="l-menu-icon l-icon l-icon-fushicaiwu"></i>
                                                        <span
                                                            style="
                                                                width: 100%;
                                                                height: 20px;
                                                                display: inline-block;
                                                                line-height: 20px;
                                                                text-indent: 0px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            请款结果
                                                        </span>
                                                    </a>
                                                </div>

                                                <div
                                                    roleid="c1112"
                                                    class="item-menu item-menu-srhx srzcMenuhover"
                                                    style="width: 70px; height: 60px; position: absolute; top: 126px; left: 685px; color: #000"
                                                >
                                                    <a
                                                        style="color: #000; height: 40px; width: 100%"
                                                        class="l-link-item"
                                                        data-tabid="42"
                                                        data-text="上缴账款"
                                                        data-url="/Payment/PaymentIndex"
                                                        data-tracktxt="上缴账款"
                                                    >
                                                        <i class="l-menu-icon l-icon l-icon-yingshouzhangshu"></i>
                                                        <span
                                                            style="
                                                                width: 100%;
                                                                height: 20px;
                                                                display: inline-block;
                                                                line-height: 20px;
                                                                text-indent: 0px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            上缴账款
                                                        </span>
                                                    </a>
                                                </div>

                                                <div
                                                    roleid="c1113"
                                                    class="item-menu item-menu-srhx"
                                                    style="width: 70px; height: 60px; position: absolute; top: 207px; left: 685px; color: #000"
                                                >
                                                    <a
                                                        style="color: #000; height: 40px; width: 100%"
                                                        class="l-link-item"
                                                        data-tabid="46"
                                                        data-text="到款确认"
                                                        data-url="/Payment/PaymentConfirm"
                                                        data-tracktxt="到款确认"
                                                    >
                                                        <i class="l-menu-icon l-icon l-icon-huidanyuejie"></i>
                                                        <span
                                                            style="
                                                                width: 100%;
                                                                height: 20px;
                                                                display: inline-block;
                                                                line-height: 20px;
                                                                text-indent: 0px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            到款确认
                                                        </span>
                                                    </a>
                                                </div>
                                                <div
                                                    roleid="c1114"
                                                    class="item-menu item-menu-zchx"
                                                    style="width: 70px; height: 60px; position: absolute; top: 287px; left: 685px; color: #000"
                                                >
                                                    <a
                                                        style="color: #000; height: 40px; width: 100%"
                                                        class="l-link-item"
                                                        data-tabid="47"
                                                        data-text="资金调拨"
                                                        onclick="opencw(this,'isJava', '资金调拨')"
                                                        lrtype="0-addzjdb"
                                                        data-tracktxt="资金调拨"
                                                    >
                                                        <i class="l-menu-icon l-icon l-icon-yingfuzhangshu"></i>
                                                        <span
                                                            style="
                                                                width: 100%;
                                                                height: 20px;
                                                                display: inline-block;
                                                                line-height: 20px;
                                                                text-indent: 0px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            资金调拨
                                                        </span>
                                                    </a>
                                                    <div
                                                        class="item-menu-secend-main srzcMenu"
                                                        style="
                                                            background: url(https://imagecdn.ymm56.com/ymmfile/static/resource/4b3c4395-92bf-485e-9e76-75cd0cafe43d.png);
                                                            background-size: 100% 100%;
                                                            width: 451px;
                                                            height: 410px;
                                                            position: absolute;
                                                            top: 0px;
                                                            left: 70px;
                                                            z-index: 9999;
                                                        "
                                                    >
                                                        <div style="float: left; margin: 20px 0px 0px 35px"></div>
                                                    </div>
                                                </div>
                                                <div
                                                    roleid="c1109"
                                                    class="item-menu item-menu-zchx"
                                                    style="width: 70px; height: 60px; position: absolute; top: 207px; left: 528px; color: #000"
                                                >
                                                    <a
                                                        style="color: #000; height: 40px; width: 100%"
                                                        class="l-link-item"
                                                        data-tabid="681"
                                                        data-text="现金日记账"
                                                        data-url="/CashDayAccount/CashDayAccount_Index?billtype=0"
                                                        data-tracktxt="现金日记账"
                                                    >
                                                        <i class="l-menu-icon l-icon l-icon-huidanyuejie"></i>
                                                        <span
                                                            style="
                                                                width: 100%;
                                                                height: 20px;
                                                                display: inline-block;
                                                                line-height: 20px;
                                                                text-indent: 0px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            现金日记账
                                                        </span>
                                                    </a>
                                                </div>
                                                <div
                                                    roleid="c1110"
                                                    class="item-menu"
                                                    style="width: 110px; height: 60px; position: absolute; top: 287px; left: 528px; color: #000"
                                                >
                                                    <a
                                                        style="color: #000; height: 40px; width: 100%"
                                                        class="l-link-item"
                                                        data-tabid="693"
                                                        data-text="银行存款日记账"
                                                        data-url="/CashDayAccount/CashDayAccount_Index?billtype=1"
                                                        data-tracktxt="银行存款日记账"
                                                    >
                                                        <i class="l-menu-icon l-icon l-icon-huokuanhuishou"></i>
                                                        <span
                                                            style="
                                                                width: 100%;
                                                                height: 20px;
                                                                display: inline-block;
                                                                line-height: 20px;
                                                                text-indent: 0px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            银行存款日记账
                                                        </span>
                                                    </a>
                                                </div>

                                                <div
                                                    roleid="c1111"
                                                    class="item-menu"
                                                    style="width: 70px; height: 60px; position: absolute; top: 369px; left: 528px; color: #000"
                                                >
                                                    <a
                                                        style="color: #000; height: 40px; width: 100%"
                                                        class="l-link-item"
                                                        data-tabid="714"
                                                        data-text="出纳审核"
                                                        data-url="/Cashier/CashierAuditing"
                                                        data-tracktxt="出纳审核"
                                                    >
                                                        <i class="l-menu-icon l-icon l-icon-huokuanfafang"></i>
                                                        <span
                                                            style="
                                                                width: 100%;
                                                                height: 20px;
                                                                display: inline-block;
                                                                line-height: 20px;
                                                                text-indent: 0px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            出纳审核
                                                        </span>
                                                    </a>
                                                </div>
                                                <div
                                                    roleid="c1115"
                                                    class="item-menu"
                                                    style="width: 70px; height: 60px; position: absolute; top: 369px; left: 685px; color: #000"
                                                >
                                                    <a style="color: #000; height: 40px; width: 100%" class="l-link-item" onclick="openzz()">
                                                        <i class="l-menu-icon l-icon l-icon-huokuandaozhang"></i>
                                                        <span
                                                            style="
                                                                width: 100%;
                                                                height: 20px;
                                                                display: inline-block;
                                                                line-height: 20px;
                                                                text-indent: 0px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            出纳扎帐
                                                        </span>
                                                    </a>
                                                </div>
                                                <div
                                                    class="item-menu"
                                                    style="
                                                        width: auto !important;
                                                        height: 30px !important;
                                                        margin: 0 auto;
                                                        color: #000;
                                                    "
                                                >
                                                    <a
                                                        style="color: #000; line-height: 30px; width: 100%; padding-top: 0"
                                                        class="l-link-item"
                                                        data-tabid="f9"
                                                        data-text="蓝桥F9介绍"
                                                        data-url="/News/F9"
                                                    >
                                                        <span>如需提供资产负债、损益及全面核算，请采用蓝桥高端F9产品></span>
                                                    </a>
                                                </div>

                                                <div class="lct-part lct-part09 bbmk" style="top: 8px; left: 840px; position: absolute">
                                                    <div class="bb">
                                                        <ul>
                                                            <li>核心报表</li>
                                                            <li roleid="c1701">
                                                                <a
                                                                    class="l-link-item item-menu-right"
                                                                    data-tabid="76"
                                                                    data-text="前台收银日报表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    gridid="25a6f163-9139-e0fb-edbc-1abf8aa3c3fc"
                                                                    data-filter="4,5,6,8"
                                                                    data-view-type="前台收银日报表"
                                                                    data-ld="true"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-label="{4:'收银日期',8:'收银员'}"
                                                                    data-tracktxt="前台收银日报表"
                                                                >
                                                                    前台收银日报表
                                                                </a>
                                                            </li>
                                                            <li roleid="c1702" class="hidedataBySetting">
                                                                <a
                                                                    class="l-link-item item-menu-right"
                                                                    data-tabid="108"
                                                                    data-text="现金收支汇总表"
                                                                    data-url="/CashClassReport/CashSZReport"
                                                                    data-tracktxt="现金收支汇总表"
                                                                >
                                                                    现金收支汇总表
                                                                </a>
                                                            </li>
                                                            <li roleid="c1703" class="hidedataBySetting">
                                                                <a
                                                                    class="l-link-item item-menu-right"
                                                                    data-tabid="78"
                                                                    data-text="出纳余额汇总表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    gridid="753d7022-0489-26c3-286f-00fd65810bef"
                                                                    data-view-type="出纳余额汇总表"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-filter="1,2,3,4,5,6"
                                                                    showacc="true"
                                                                    data-tracktxt="出纳余额汇总表"
                                                                >
                                                                    出纳余额汇总表
                                                                </a>
                                                            </li>

                                                            <li roleid="c1704" class="hidedataBySetting">
                                                                <a
                                                                    class="l-link-item item-menu-right"
                                                                    data-tabid="80"
                                                                    data-text="科目明细分类账"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    gridid="698deb10-9f85-0af8-aca0-8221dc5effe2"
                                                                    data-view-type="科目明细分类账"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-filter="1,2,3,4,5,6"
                                                                    showlayout="true"
                                                                    showacc="true"
                                                                    data-tracktxt="科目明细分类账"
                                                                >
                                                                    科目明细分类账
                                                                </a>
                                                            </li>
                                                            <li roleid="c1705">
                                                                <a
                                                                    class="l-link-item item-menu-right"
                                                                    data-tabid="79"
                                                                    data-text="客户账龄分析表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    data-view-type="客户账龄分析表"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-filter="9,10,6,8,11"
                                                                    data-label="{9:'期间截止到',8:'统计对象'}"
                                                                    data-tracktxt="客户账龄分析表"
                                                                >
                                                                    客户账龄分析表
                                                                </a>
                                                            </li>
                                                            <li roleid="c1706" class="hidedataBySetting">
                                                                <a
                                                                    class="l-link-item item-menu-right"
                                                                    data-tabid="81"
                                                                    data-text="应收应付汇总表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    gridid="b25e0818-b8e6-3305-d423-ffc91f654fe6"
                                                                    data-view-type="应收应付汇总表"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-filter="27,4,5,6"
                                                                    data-tracktxt="应收应付汇总表"
                                                                >
                                                                    应收应付汇总表
                                                                </a>
                                                            </li>
                                                            <li roleid="c1707">
                                                                <a
                                                                    class="l-link-item item-menu-right"
                                                                    data-tabid="82"
                                                                    data-text="日记账变动报表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    gridid="43873d30-3923-b85b-8a08-a9b126a4f7f2"
                                                                    data-view-type="日记账变动报表"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-filter="4,5,6"
                                                                    data-tracktxt="日记账变动报表"
                                                                >
                                                                    日记账变动报表
                                                                </a>
                                                            </li>
                                                            <li roleid="c1708">
                                                                <a
                                                                    class="l-link-item item-menu-right"
                                                                    data-tabid="83"
                                                                    data-text="单车毛利表"
                                                                    data-url="/ReportTpl/Index"
                                                                    gridid="32707520-6f8f-a473-eabd-9faaa7a63016"
                                                                    data-type="report"
                                                                    data-view-type="单车毛利表"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-filter="4,5,6,7,12"
                                                                    data-label="{4:'发车时间'}"
                                                                    data-tracktxt="单车毛利表"
                                                                >
                                                                    单车毛利表
                                                                </a>
                                                            </li>
                                                            <template>
                                                                <li roleid="c1709">
                                                                    <a
                                                                        v-if="argTplObj.isNewBsiteProfit == 1"
                                                                        class="l-link-item item-menu-right"
                                                                        data-tabid="833"
                                                                        data-text="网点利润表"
                                                                        data-url="/ReportTpl/branchProfit?type=1"
                                                                        data-tracktxt="网点利润表"
                                                                    >
                                                                        网点利润表
                                                                    </a>
                                                                    <a
                                                                        v-else
                                                                        class="l-link-item item-menu-right"
                                                                        data-tabid="833"
                                                                        data-text="网点利润表"
                                                                        data-url="/ReportTpl/Index"
                                                                        data-type="report"
                                                                        data-view-type="网点利润表"
                                                                        data-ajax-url="/ReportTpl/GetDataCommon"
                                                                        data-tracktxt="网点利润表"
                                                                        :data-filter="
                                                                            getCustomConfig('old_branch_profit_statement_old_filter') ? '32,2,3,9,10,6' : '4,5,6'
                                                                        "
                                                                        :data-label="
                                                                            getCustomConfig('old_branch_profit_statement_old_filter') ? `{2:'区间从',9:'到'}` : '' 
                                                                        " 
                                                                    >
                                                                        网点利润表
                                                                    </a>
                                                                    <!-- 网点利润表 202509151159143033173 73367改成年月的筛选项 -->
                                                                    <!-- 网点利润表 202508131148539407401 公版改成79913，80617的日期时间选择器 -->
                                                                    <!-- :data-filter="
                                                                            tmscode === '79913' || tmscode === '80617' ? '4,5,6' : '32,2,3,9,10,6'
                                                                        "
                                                                        :data-label="
                                                                            tmscode === '79913' || tmscode === '80617' ? '' : `{2:'区间从',9:'到'}`
                                                                        " -->
                                                                </li>
                                                            </template>
                                                            <li roleid="c1710">
                                                                <a
                                                                    class="l-link-item item-menu-right"
                                                                    data-tabid="834"
                                                                    data-text="线路利润表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    data-view-type="线路利润表"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-filter="32,2,3,9,10,6,7"
                                                                    data-label="{2:'区间从',9:'到'}"
                                                                    data-tracktxt="线路利润表"
                                                                >
                                                                    线路利润表
                                                                </a>
                                                            </li>
                                                            <!-- 202509281413156109561 86980 自定义隶属站点复制隶属线路功能 但是不显示隶属线路利润表 -->
                                                            <template v-if="isPublicLSXLFlag && !getCustomConfig('custom_ls_site_copy_lsxl')">
                                                                <li roleid="c1710">
                                                                    <a
                                                                        class="l-link-item item-menu-right"
                                                                        data-tabid="837"
                                                                        data-text="隶属线路利润表"
                                                                        data-url="/ReportTpl/Index"
                                                                        data-type="report"
                                                                        data-view-type="隶属线路利润表"
                                                                        data-ajax-url="/ReportTpl/GetDataCommon"
                                                                        data-filter="32,2,3,9,10,6,7"
                                                                        data-label="{2:'区间从',9:'到'}"
                                                                        data-tracktxt="隶属线路利润表"
                                                                    >
                                                                        隶属线路利润表
                                                                    </a>
                                                            </li>
                                                            </template>
                                                            <template v-if="getCustomConfig('show_profit_loss_statement')">
                                                                <li roleid="c1711">
                                                                    <a
                                                                    class="l-link-item item-menu-right"
                                                                    data-tabid="838"
                                                                    data-text="分成利润表"
                                                                    data-unsite="true"
                                                                    data-url="/ReportTpl/Index"
                                                                    gridid="d453fb6f-5985-43ff-93cf-ba51250538f6"
                                                                    data-type="report"
                                                                    data-view-type="分成利润表"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-filter="4,5,6,7,12"
                                                                    data-label="{4:'发车时间'}"
                                                                    data-tracktxt="分成利润表"
                                                                    >
                                                                        分成利润表
                                                                    </a>
                                                                </li>
                                                            </template>

                                                              <template v-if="getCustomConfig('show_profit_loss_statement')">
                                                                <li roleid="c1712">
                                                                    <a
                                                                    class="l-link-item item-menu-right"
                                                                    data-tabid="lasa-838"
                                                                    data-text="拉萨线利润表"
                                                                    data-unsite="true"
                                                                    data-url="/ReportTpl/Index"
                                                                    gridid="a65883a9-1499-43dc-bf4e-075323b4da0f"
                                                                    data-type="report"
                                                                    data-view-type="拉萨线利润表"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-filter="4,5,6,7,12"
                                                                    data-label="{4:'发车时间'}"
                                                                    data-tracktxt="拉萨线利润表"
                                                                    >
                                                                        拉萨线利润表
                                                                    </a>
                                                                </li>
                                                            </template>


                                                            <template
                                                                v-if="
                                                                    tmscode === '88987' ||
                                                                    tmscode === '82635' ||
                                                                    tmscode === '83956' ||
                                                                    tmscode === '86308'
                                                                "
                                                            >
                                                                <li>
                                                                    <a
                                                                        class="l-link-item item-menu-right"
                                                                        data-tabid="835"
                                                                        data-text="网点收支财务统计表"
                                                                        data-url="/ReportTpl/SiteAccount"
                                                                        data-type="report"
                                                                        data-view-type="网点收支财务统计表"
                                                                        data-tracktxt="网点收支财务统计表"
                                                                    >
                                                                        网点收支财务统计表
                                                                    </a>
                                                                </li>
                                                            </template>
                                                            <template v-if="tmscode === '79358'">
                                                                <li>
                                                                    <a
                                                                        class="l-link-item item-menu-right"
                                                                        data-tabid="836"
                                                                        data-text="预收付款查询"
                                                                        data-url="/ReportTpl/YSFQuery"
                                                                        data-type=" report"
                                                                        data-view-type="预收付款查询"
                                                                    >
                                                                        预收付款查询
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>

                                        <li class="small-menu cw-samll-title white-list-module" roleid="c12">
                                            <a class="main-menu-bar" data-tracktxt="财务对账">
                                                <span class="cw-center-li-span">财务对账</span>
                                                <i class="mheadersj"></i>
                                            </a>
                                            <div id="min-menu-cwdz" class="min-menu" style="overflow-y: auto;margin-top:-20px;">
                                                <div class="menu-part-body showByGAJ" style="display: none">
                                                    <div class="menu-part-tit">财务做账</div>
                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c1105">
                                                            <a class="l-link-item" onclick="opencw(this,'isJava')" lrtype="0-add">
                                                                <i class="l-cw-icon l-icon l-icon-fushicaiwu"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">现金录入</span>
                                                                    <span class="menu-part-summary">现金录入</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1109">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="681"
                                                                data-text="现金日记账"
                                                                data-url="/CashDayAccount/CashDayAccount_Index?billtype=0"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-huidanyuejie"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">现金日记账</span>
                                                                    <span class="menu-part-summary">现金日记账</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1701">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="76"
                                                                data-text="前台收银日报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                gridid="25a6f163-9139-e0fb-edbc-1abf8aa3c3fc"
                                                                data-filter="4,5,6,8"
                                                                data-view-type="前台收银日报表"
                                                                data-ld="true"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                                data-label="{4:'收银日期',8:'收银员'}"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-huidanyuejie"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">前台收银日报表</span>
                                                                    <span class="menu-part-summary">前台收银日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>

                                                        <div class="claer"></div>
                                                    </div>
                                                </div>
                                                <div class="menu-part-body">
                                                    <div class="menu-part-tit">客户</div>
                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c1201">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="84"
                                                                data-text="客户对账"
                                                                data-url="/FinancialReconciliation/CustomerReconciliation_F9"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-kehuduizhang"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">客户对账</span>
                                                                    <span class="menu-part-summary">发货和收货客户运费对账</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1202">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="86"
                                                                data-text="客户对账单"
                                                                data-url="/FinancialReconciliation/ReconciliationBill"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-huokuanzongzhangbaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">客户对账单</span>
                                                                    <span class="menu-part-summary">对账单</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="claer"></div>
                                                    </div>
                                                    <div class="menu-class" id="khydz" style="display: none">
                                                        <div class="claer"></div>
                                                        <div class="menu-part" roleid="c1213">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="84_1"
                                                                data-text="客户预对账"
                                                                data-url="/FinancialReconciliation/CustomerReconciliationYdz_F9"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-kehuduizhang"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">客户预对账</span>
                                                                    <span class="menu-part-summary">发货和收货客户运费预对账</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1214">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="86_1"
                                                                data-text="客户预对账单"
                                                                data-url="/FinancialReconciliation/ReconciliationBillYdz"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-huokuanzongzhangbaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">客户预对账单</span>
                                                                    <span class="menu-part-summary">预对账单</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="claer"></div>
                                                    </div>
                                                    <template v-if="tmscode === '80712' || tmscode === '88152'">
                                                        <div class="menu-class">
                                                            <div class="menu-part" roleid="c1209">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="852"
                                                                    data-text="驻点对账"
                                                                    data-url="/FinancialReconciliation/Residentreconciliation"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-dailiduizhang"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">驻点对账</span>
                                                                        <span class="menu-part-summary">驻点总运费对账</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div class="menu-part" roleid="c1210">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="862"
                                                                    data-text="驻点对账对账单"
                                                                    data-url="/FinancialReconciliation/ResidentreconciliationBill"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-huokuanzongzhangbaobiao"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">驻点对账单</span>
                                                                        <span class="menu-part-summary">对账单</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div class="claer"></div>
                                                        </div>
                                                    </template>
                                                    <template v-if="tmscode === '82431'">
                                                        <div class="menu-class">
                                                            <div class="menu-part" roleid="c1211dz">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="852_82431"
                                                                    data-text="制单人结算对账"
                                                                    data-url="/FinancialReconciliation/ChaufferReconciliation?ctype=0"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-dailiduizhang"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">制单人结算对账</span>
                                                                        <span class="menu-part-summary">制单人结算对账</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div class="menu-part" roleid="c1212dz">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="853_82431"
                                                                    data-text="制单人结算对账单"
                                                                    data-url="/FinancialReconciliation/ChaufferReconciliationBill?ctype=0"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-huokuanzongzhangbaobiao"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">制单人结算对账单</span>
                                                                        <span class="menu-part-summary">制单人结算对账单</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div class="claer"></div>
                                                        </div>
                                                        <div class="menu-class">
                                                            <div class="menu-part" roleid="c1213dz">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="854_82431"
                                                                    data-text="司机结算对账"
                                                                    data-url="/FinancialReconciliation/ChaufferReconciliation?ctype=1"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-dailiduizhang"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">司机结算对账</span>
                                                                        <span class="menu-part-summary">司机结算对账</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div class="menu-part" roleid="c1214dz">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="855_82431"
                                                                    data-text="司机结算对账单"
                                                                    data-url="/FinancialReconciliation/ChaufferReconciliationBill?ctype=1"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-huokuanzongzhangbaobiao"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">司机结算对账单</span>
                                                                        <span class="menu-part-summary">司机结算对账单</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div class="claer"></div>
                                                        </div>
                                                    </template>
                                                </div>
                                                <div class="menu-part-body">
                                                    <div class="menu-part-tit">承运商</div>
                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c1203">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="851"
                                                                data-text="代理对账"
                                                                data-url="/FinancialReconciliation/AgentReconciliation"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-dailiduizhang"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">代理对账</span>
                                                                    <span class="menu-part-summary">三方承运商中转费用对账</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1204">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="861"
                                                                data-text="代理对账单"
                                                                data-url="/FinancialReconciliation/AgentReconciliationBill"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-huokuanzongzhangbaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">代理对账单</span>
                                                                    <span class="menu-part-summary">对账单</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="claer"></div>
                                                    </div>
                                                    <div class="menu-class" id="cysydz" style="display: none">
                                                        <div class="menu-part" roleid="c1215">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="851_1"
                                                                data-text="代理预对账"
                                                                data-url="/FinancialReconciliation/AgentReconciliationYdz"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-dailiduizhang"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">代理预对账</span>
                                                                    <span class="menu-part-summary">三方承运商中转费用预对账</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1216">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="861_1"
                                                                data-text="代理预对账单"
                                                                data-url="/FinancialReconciliation/AgentReconciliationBillYdz"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-huokuanzongzhangbaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">代理预对账单</span>
                                                                    <span class="menu-part-summary">预对账单</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="claer"></div>
                                                    </div>
                                                </div>
                                                <div class="menu-part-body">
                                                    <div class="menu-part-tit">车队相关</div>
                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c1205">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="87"
                                                                data-text="长途车对账"
                                                                data-url="/FinancialReconciliation/CoachReconciliation"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-changtucheduizhang"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">长途车对账</span>
                                                                    <span class="menu-part-summary">干线配载车辆运费对账</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1206">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="88"
                                                                data-text="短途车对账"
                                                                data-url="/FinancialReconciliation/ShorthaulReconciliation"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-duantucheduizhang"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">短途车对账</span>
                                                                    <span class="menu-part-summary">短线接驳车辆运费对账</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div style='width: 100%;' v-if="!['81697','63165','72162'].includes(tmscode)">
                                                            <div class="menu-part" roleid="c1217">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="89"
                                                                    data-text="短途车对账（含对账）"
                                                                    data-type="dtc"
                                                                    data-url="/FinancialReconciliation/ShorthaulReconciliation"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-duantucheduizhang"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">短途车对账(含对账)</span>
                                                                        <span class="menu-part-summary">短线接驳车辆运费对账（含对账）</span>
                                                                    </span>
                                                                </a>
                                                            </div>

                                                            <div class="menu-part" roleid="c1218" >
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="90"
                                                                    data-text="短途车对账单"
                                                                    data-url="/FinancialReconciliation/ReconciliationBillDtc"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-duantucheduizhang"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">短途车对账单</span>
                                                                        <span class="menu-part-summary">对账单</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </div>


                                                        <div class="claer"></div>
                                                    </div>
                                                </div>
                                                <div class="menu-part-body">
                                                    <div class="menu-part-tit">分公司对账</div>
                                                    <div class="menu-class" style="overflow: hidden">
                                                        <div class="menu-part" roleid="c1207">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="8127"
                                                                data-text="分公司对账"
                                                                data-url="/FinancialReconciliation/Filiale"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-fengongsiduizhang"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">分公司对账</span>
                                                                    <span class="menu-part-summary">分公司往来费用对账</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1208">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="8126"
                                                                data-text="分公司对账单"
                                                                data-url="/FinancialReconciliation/Company_ReconciliationBill"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-fengongsiduizhang"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">分公司对账单</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div style='width: 100%' v-if="hasBranchReconciliationDetail">
                                                            <div class="menu-part" roleid="c1219">
                                                                <a class="l-link-item" data-tabid="8125" data-text="分公司对账明细单"
                                                                    data-url="/FinancialReconciliation/Company_ReconciliationBill_ByDispatch">
                                                                    <i class="l-cw-icon l-icon l-icon-fengongsiduizhang"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">分公司对账明细单</span>
                                                                        <span class="menu-part-summary">对账明细单</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    
                                                    <div class="claer"></div>
                                                </div>
                                                

                                                

                                                <div class="menu-part-body" id="divBranch">
                                                    <div class="menu-part-tit">代收网点对账</div>
                                                    <div class="menu-class" style="overflow: hidden">
                                                        <div class="menu-part" roleid="c1207">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="8128"
                                                                data-text="代收网点对账"
                                                                data-url="/FinancialReconciliation/BranchReconciliation_F9"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-fengongsiduizhang"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">代收网点对账</span>
                                                                    <span class="menu-part-summary">代收网点分成对账</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1207">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="8129"
                                                                data-text="代收网点对账单"
                                                                data-url="/FinancialReconciliation/BranchReconciliationBill"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-fengongsiduizhang"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">代收网点对账单</span>
                                                                    <span class="menu-part-summary">代收网点对账单</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="menu-part-body" id="divSFDZ" style="display: none">
                                                    <div class="menu-part-tit">师傅对账</div>
                                                    <div class="menu-class" style="overflow: hidden">
                                                        <div class="menu-part" roleid="c1211">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="sf8128"
                                                                data-text="师傅对账"
                                                                data-url="/FinancialReconciliation/SFReconciliation"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-fengongsiduizhang"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">师傅对账</span>
                                                                    <span class="menu-part-summary">师傅的费用对账</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1212">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="sf8129"
                                                                data-text="师傅对账单"
                                                                data-url="/FinancialReconciliation/SFReconciliationBill"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-fengongsiduizhang"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">师傅对账单</span>
                                                                    <span class="menu-part-summary">师傅的费用对账单</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="menu-part-body" id="divSJDZ" style="display: none">
                                                    <div class="menu-part-tit">司机对账单</div>
                                                    <div class="menu-class" style="overflow: hidden">
                                                        <div class="menu-part" roleid="c1211">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="sf8130"
                                                                data-text="司机对账单"
                                                                data-url="/FinancialReconciliation/SJReconciliation"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-fengongsiduizhang"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">司机对账单</span>
                                                                    <span class="menu-part-summary">司机的费用对账单</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="menu-part-body" v-if='enableOnePriceReconciliation'>
                                                    <div class="menu-part-tit">一口价对账</div>
                                                    <div class="menu-class" style="overflow: hidden">
                                                        <div class="menu-part" roleid="c1217">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="OneSetPrice"
                                                                data-text="一口价对账"
                                                                data-url="/FinancialReconciliation/OneSetPrice"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-fengongsiduizhang"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">一口价对账</span>
                                                                    <span class="menu-part-summary">一口价往来费用对账</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1218">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="OneSetPriceBill"
                                                                data-text="一口价对账单"
                                                                data-url="/FinancialReconciliation/OneSetPriceBill"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-fengongsiduizhang"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">一口价对账单</span>
                                                                    <span class="menu-part-summary">一口价往来费用对账单</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div class="claer"></div>
                                                </div>
                                            </div>
                                        </li>

                                        <li class="small-menu cw-samll-title white-list-module" roleid="c13">
                                            <a class="main-menu-bar" data-tracktxt="财务工具">
                                                <span class="cw-center-li-span">财务工具</span>
                                                <i class="mheadersj"></i>
                                            </a>
                                            <div id="min-menu-cwgj" class="min-menu" style="overflow-y: auto;margin-top:-20px;">
                                                <div class="menu-part-body">
                                                    <div class="menu-part-tit">常用工具</div>
                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c1301">
                                                            <a class="l-link-item" onclick="openEditWayBill(2)">
                                                                <i class="l-cw-icon l-icon l-icon-xiugaiyundan"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">修改运单</span>
                                                                    <span class="menu-part-summary">在未结款的情况下可修改</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1302">
                                                            <a class="l-link-item" onclick="openEditWayBill(3)">
                                                                <i class="l-cw-icon l-icon l-icon-delete" style="background: none"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">删除运单</span>
                                                                    <span class="menu-part-summary">在运单未结款状态下可删除</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1303">
                                                            <a class="l-link-item" onclick="openEditWayBill(4)">
                                                                <i class="l-cw-icon l-icon l-icon-yunfeiyidong"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">运费异动</span>
                                                                    <span class="menu-part-summary">不改变原单金额情况下异动运费</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="claer"></div>
                                                    </div>

                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c1304">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="92"
                                                                data-text="改单处理"
                                                                data-url="/FinancialInstruments/ChangeWaybill"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-gaidanchuli"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">改单审批</span>
                                                                    <span class="menu-part-summary">通过改单申请的运单做审批处理</span>
                                                                </span>
                                                            </a>
                                                        </div>

                                                        <div class="menu-part" roleid="c1305">
                                                            <a class="l-link-item" onclick="openEditWayBill(12)">
                                                                <i class="l-cw-icon l-icon l-icon-tuihuochuli"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">退货处理</span>
                                                                    <span class="menu-part-summary">处理退货或拒绝签收的运单</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1306">
                                                            <a class="l-link-item" onclick="openCarFeeAddorsub()">
                                                                <i class="l-cw-icon l-icon l-icon-tuihuochuli"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">大车费增减款</span>
                                                                    <span class="menu-part-summary">办理大车费的扣款及奖励操作</span>
                                                                </span>
                                                            </a>
                                                        </div>

                                                        <div class="claer"></div>
                                                    </div>
                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c1307">
                                                            <a class="l-link-item" onclick="openEditWayBill(11)">
                                                                <i class="l-cw-icon l-icon l-icon-fanghuotiaozheng"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">放货调整</span>
                                                                    <span class="menu-part-summary">对等通知放货的货物进行放控调整</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1308">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="97"
                                                                data-text="凭证反核销"
                                                                data-url="/FinancialInstruments/ReverseWriteOff"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-pingzhengfanhexiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">反核销</span>
                                                                    <span class="menu-part-summary">核销错误的凭证反向操作,取消核销</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1309">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="99"
                                                                data-text="客户合并"
                                                                data-url="/FinancialInstruments/CustomerMerger"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-kehuhebing"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">客户合并</span>
                                                                    <span class="menu-part-summary">名称合并,如张总,张老板,可合并为张三</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="claer"></div>
                                                    </div>
                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c1310">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="100"
                                                                data-text="代理合并"
                                                                data-url="/FinancialInstruments/ProxyMerger"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-dailihebing"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">代理合并</span>
                                                                    <span class="menu-part-summary">承运商合并,如德邦,德邦物流,可合并为德邦</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1316">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="101"
                                                                data-text="运单审核"
                                                                data-url="/Billing/unitCheck"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-wangluodingdan"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">运单审核</span>
                                                                    <span class="menu-part-summary">审核托运单，审核后不能修改、删除</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1317">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="102"
                                                                data-text="运单作废"
                                                                data-url="/Billing/CancelBill"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-shanchudingdan"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">运单作废</span>
                                                                    <span class="menu-part-summary">作废托运单，作废后可删除</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="claer"></div>
                                                    </div>
                                                    <div class="menu-class">
                                                        <template v-if="tmscode === '84400'">
                                                            <div class="menu-part" roleid="c1320">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="1255140118"
                                                                    gridid="f08fdaac-f8e4-4b02-ba14-4c35cd92d678"
                                                                    data-text="批量修改运费"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    data-label="{20:'类型'}"
                                                                    data-view-type="批量修改运费"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-filter="27,4,5,6,7"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">批量修改运费</span>
                                                                        <span class="menu-part-summary">批量修改运费构成中涵盖的费用项目</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>

                                                        <div class="menu-part showBy79808" roleid="c1318">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="1010"
                                                                data-text="费用审核"
                                                                data-url="/Billing/AccCheck"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-wangluodingdan"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">费用审核</span>
                                                                    <span class="menu-part-summary">审核费用信息，审核后不能修改、删除</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1319">
                                                            <a class="l-link-item" data-text="网络订单生成托运单" onclick="openEditWayBill(13)">
                                                                <i class="l-cw-icon l-icon l-icon-wangluodingdan"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">网络订单生成托运单</span>
                                                                    <span class="menu-part-summary">将网络来源的数据快速生成托运单</span>
                                                                </span>
                                                            </a>
                                                        </div>

                                                        <div class="menu-part" roleid="" v-show="enableYsyfModule">
                                                            <a class="l-link-item" data-tabid="orderFeeAdjust" data-text="运单收支调整" data-url="/AcceptanceOfBill/orderFeeOutInAdjust">
                                                                <i class="l-cw-icon l-icon l-icon-wangluodingdan"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">运单收支调整</span>
                                                                    <span class="menu-part-summary">运单收支调整</span>
                                                                </span>
                                                            </a>
                                                        </div>
                        
                                                        <template v-if="tmscode === '72162'">
                                                            <div class="menu-part">
                                                                <a class="l-link-item" data-text="其他费用" onclick="openOtherExpensesInfo()">
                                                                    <i class="l-cw-icon l-icon l-icon-wangluodingdan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">其他费用</span>
                                                                        <span class="menu-part-summary">其他费用</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>
                                                        <template v-if="tmscode === '87868'">
                                                            <div class="menu-part" roleid="c1320">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="PressForMoney"
                                                                    data-text="催款管理"
                                                                    data-url="/PressForMoney/Index"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-wangluodingdan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">催款管理</span>
                                                                        <span class="menu-part-summary">催款管理</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>
                                                        <template v-if="tmscode === '84420'">
                                                            <div class="menu-part" roleid="c1320">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="103"
                                                                    data-text="费用支出登记"
                                                                    data-url="/OtherFee/OtherFeeList"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-wangluodingdan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">费用支出登记</span>
                                                                        <span class="menu-part-summary">费用支出登记</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>
                                                        <template v-if="tmscode === '82635' || tmscode === '86415'">
                                                            <div class="menu-part">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="ReturnBill"
                                                                    data-text="原货返回"
                                                                    data-url="/Billing/ReturnBill"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-wangluodingdan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">原货返回</span>
                                                                        <span class="menu-part-summary">原货返回</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>
                                                        <div class="claer"></div>
                                                    </div>
                                                </div>
                                                <div class="menu-part-body">
                                                    <div class="menu-part-tit">货款工具</div>
                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c1311">
                                                            <a class="l-link-item" onclick="openEditWayBill(5)">
                                                                <i class="l-cw-icon l-icon l-icon-huokuanbiangeng"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">货款变更</span>
                                                                    <span class="menu-part-summary">不改变原单金额情况下变更货款</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1312">
                                                            <a class="l-link-item" onclick="openEditWayBill(6)">
                                                                <i class="l-cw-icon l-icon l-icon-huokuanquxiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">货款取消</span>
                                                                    <span class="menu-part-summary">取消代收货款</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1313">
                                                            <a class="l-link-item" onclick="openEditWayBill(7)">
                                                                <i class="l-cw-icon l-icon l-icon-huokuanhuifu"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">货款恢复</span>
                                                                    <span class="menu-part-summary">恢复取消的货款为正常代收</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="claer"></div>
                                                    </div>
                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c1314">
                                                            <a class="l-link-item" onclick="openEditWayBill(8)">
                                                                <i class="l-cw-icon l-icon l-icon-huokuanguashi"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">货款挂失</span>
                                                                    <span class="menu-part-summary">挂失后不影响回收货款，但不允许发放</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1315">
                                                            <a class="l-link-item" onclick="openEditWayBill(9)">
                                                                <i class="l-cw-icon l-icon l-icon-quxiaoguashi"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">取消挂失</span>
                                                                    <span class="menu-part-summary">货款挂失取消后，允许发放货款</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="claer"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>

                                        <li class="small-menu cw-samll-title white-list-module" :class="{'hidden-no-permission-menu': getCustomizedConfigByKey('remove_grayed_out_reports') }">
                                            <a class="main-menu-bar" data-tracktxt="报表中心">
                                                <span class="cw-center-li-span">报表中心</span>
                                                <i class="mheadersj"></i>
                                            </a>
                                            <div id="min-menu-bbzx" class="min-menu bbcenter" style="margin-top:-20px;">
                                                <div class="menu-part-body">
                                                    <div class="menu-part-tit" report-type="rcl">日常类</div>
                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c140101">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="107"
                                                                gridid="686bbe61-97a9-48d4-e26d-d7cadb0aeee0"
                                                                data-text="运单大全"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-view-type="运单大全"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                                data-filter="27,4,5,6,7"
                                                                :data-unsite="tmscode == '84092'"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">运单大全</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part hidedataBySetting" roleid="c140102">
                                                            <a
                                                                class="l-link-item"
                                                                gridid="b86e1d9b-58e4-b904-415d-0aa4630e2e2f"
                                                                data-tabid="109"
                                                                data-text="营业额汇总表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-view-type="营业额汇总表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                                data-filter="4,5,6,7,13,31"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yingyeehuizongbiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">营业额汇总表</span>
                                                                </span>
                                                            </a>
                                                        </div>

                                                        <div class="menu-part" roleid="c140103">
                                                            <a
                                                                class="l-link-item"
                                                                gridid="c18dc923-8de0-2da6-7210-f0a59f62aa5e"
                                                                data-tabid="112"
                                                                data-text="未签货物日报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-view-type="未签货物日报表"
                                                                data-unsite="true"
                                                                data-filter="4,5,6,7"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-weiqianhuowuribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">未签货物日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>

                                                        <div class="claer"></div>
                                                    </div>
                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c140104">
                                                            <a
                                                                class="l-link-item"
                                                                gridid="1e755ae2-60bf-23e6-452a-d0b58a5d5e7e"
                                                                data-tabid="113"
                                                                data-text="未出库货物日报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-view-type="未出库货物日报表"
                                                                data-unsite="true"
                                                                data-filter="4,5,6,7"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-weichukuhuowuribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">未出库货物日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140105">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="111"
                                                                gridid="aa154c05-be61-67c0-35b5-6026543d93c2"
                                                                data-text="货物中转日报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-filter="4,5,6,17"
                                                                data-ld2="true"
                                                                data-view-type="货物中转日报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-huowuzhongzhuanribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">货物中转日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140106">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="1151"
                                                                gridid="4a6ab95f-bfe7-973c-8a96-79e59141e707"
                                                                data-text="业务员对账报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-view-type="业务员对账报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                                data-filter="21,4,5,6,7,18"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">业务员对账报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="claer"></div>
                                                    </div>
                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c140107">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="1152"
                                                                gridid="82c3f23a-933d-2578-47af-8f5eda537fa1"
                                                                data-text="发车明细报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-view-type="发车明细报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                                data-filter="29,4,5,6,7,19"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">发车明细报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140108">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="1153"
                                                                gridid="ffdedc20-1858-e93a-ba99-68737cc0dd0e"
                                                                data-text="扫码收款报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-label="{20:'类型'}"
                                                                data-view-type="扫码收款报表"
                                                                data-ajax-url="/Pay/GetDataCommon"
                                                                data-filter="28,4,5,6,20"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">移动支付明细账</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140109">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="1154"
                                                                gridid="95205db2-f41f-5d1a-bbcb-711ccafde207"
                                                                data-text="网点出库报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-label="{20:'类型'}"
                                                                data-view-type="网点出库报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                                data-filter="4,5,6,7"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">网点出库报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c140110">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="1155"
                                                                gridid="d06c98fb-be08-d488-7861-13d89f419a72"
                                                                data-text="运单图片报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-label="{20:'类型'}"
                                                                data-view-type="运单图片报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                                data-filter="4,5,6"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">运单图片报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140112">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="1156"
                                                                gridid="d376e016-c8c6-8dd0-7e73-1e5ec5459927"
                                                                data-text="大车费核销日报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-label="{4:'发车日期'}"
                                                                data-view-type="大车费核销日报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                                data-filter="4,5,6,7"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">大车费核销日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140116">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="113"
                                                                gridid="f267c7ea-a4f4-9b90-907f-1c6c9d38e273"
                                                                data-text="返款日报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-filter="4,5,6,7"
                                                                data-view-type="返款日报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-huowuzhongzhuanribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">返款日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                    </div>

                                                    <div class="menu-class">
                                                        <template v-if="tmscode === '80712' || tmscode === '88152'">
                                                            <div class="menu-part" roleid="c140114">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="1159"
                                                                    gridid="d88a303e-0c8c-39c9-cba3-4ba850c6dfbc"
                                                                    data-text="货损明细汇总表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    data-label="{4:'登记日期'}"
                                                                    data-view-type="货损明细汇总表"
                                                                    data-ajax-url="/QualityManage/GetCargodamagetms"
                                                                    data-filter="4,5,6,7"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">货损明细汇总表</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>
                                                        <template v-if="tmscode === '78976'">
                                                            <div class="menu-part" roleid>
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="1157"
                                                                    gridid
                                                                    data-text="客户返点报表"
                                                                    data-url="/CustomerProfiles/CustomerRebate"
                                                                    data-type="report"
                                                                    data-label
                                                                    data-view-type="客户返点报表"
                                                                    data-ajax-url
                                                                    data-filter="4,5,6,7"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">客户返点报表</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div class="menu-part" roleid>
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="1158"
                                                                    gridid
                                                                    data-text="网点返点报表"
                                                                    data-url="/zzjg/BranchesRebates"
                                                                    data-type="report"
                                                                    data-label
                                                                    data-view-type="网点返点报表"
                                                                    data-ajax-url
                                                                    data-filter="4,5,6,7"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">网点返点报表</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>
                                                        <template v-if="tmscode === '63165'">
                                                            <div class="menu-part" roleid="c140115">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="1160"
                                                                    gridid="d64bcf93-b489-4d94-dbff-47e900911a84"
                                                                    data-text="系统收支报表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    data-view-type="系统收支报表"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-filter="4,5"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">系统收支报表</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>
                                                        <template v-if="tmscode === '84820'">
                                                            <div class="menu-part" roleid="c140114_dz">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="1159"
                                                                    gridid="3ec8648d-6e99-4932-1e10-3798cf5d4a71"
                                                                    data-text="提成明细表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    data-label="{20:'类型'}"
                                                                    data-view-type="提成明细表"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-filter="4,5,6,7"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">提成明细表</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>
                                                        <div class="menu-part" roleid="c140117">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="1255"
                                                                gridid="b2e919c0-5667-0458-d534-7f4650b17f4d"
                                                                data-text="PDA扫码报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-label="{20:'类型'}"
                                                                data-view-type="PDA扫码报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                                data-filter="4,5,6"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">PDA扫码报表</span>
                                                                </span>
                                                            </a>
                                                        </div>

                                                        <div class="menu-part" roleid="c140111" id="onlinehide">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="1156"
                                                                gridid="9a266b99-b341-41e8-a45c-40257d0219b2"
                                                                data-text="网上对账报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-view-type="网上对账报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                                data-filter="4,5,6,7,22"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">网上对账报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140101" id="endsiteml">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="1156"
                                                                gridid="c0d2e494-7054-c6c2-8883-4084b249e612"
                                                                data-text="末端结算利润表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-unsite="true"
                                                                data-view-type="末端结算利润表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                                data-filter="4,5,6,7,12"
                                                                data-label="{4:'发车时间'}"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">末端结算利润表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140113" id="ondivideinto">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="1158"
                                                                gridid="b9d584db-9c4a-93c3-e66d-50a4dd6e785c"
                                                                data-text="分成比例报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-view-type="分成比例报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                                data-filter="4,5,6,7"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">分成比例报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140118">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="1172"
                                                                gridid="87a3bd60-e010-0e47-b8a9-ea876d4bb8b5"
                                                                data-text="实名验证记录"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-view-type="实名验证记录"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                                data-filter="4,5,6,7"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">实名验证记录</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <template v-if="tmscode === '79927'">
                                                            <div class="menu-part" roleid="c140118">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="9a6c9920-383f-866a-c328-ce9e49de2eaa"
                                                                    gridid="9a6c9920-383f-866a-c328-ce9e49de2eaa"
                                                                    data-text="运单时效统计表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    data-view-type="运单时效统计表"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-filter="4,5,6"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">运单时效统计表</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>
                                                        <template v-if="tmscode === '82635'">
                                                            <div class="menu-part">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="678692f5-f5cf-e67a-82a2-565e2bec7ba8"
                                                                    gridid="678692f5-f5cf-e67a-82a2-565e2bec7ba8"
                                                                    data-text="司机对账表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    data-view-type="司机对账表"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-filter="4,5,6"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">司机对账表</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>
                                                        <template v-if="tmscode === '84420'">
                                                            <div class="menu-part" roleid="c140119">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="678692f5-f5cf-e67a-82a2-565e2bec7ba8"
                                                                    gridid="678692f5-f5cf-e67a-82a2-565e2bec7ba8"
                                                                    data-text="小程序收支报表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    data-view-type="小程序收支报表"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-filter="4,5,6"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">小程序收支报表</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>

                                                        <template v-if="tmscode === '87973'">
                                                            <div class="menu-part" roleid="c140121">
                                                                <a
                                                                    class="l-link-item"
                                                                    gridid="4ff13ec1-3e63-1a96-8103-74e00b0bf48f"
                                                                    data-tabid="112"
                                                                    data-text="客服评价"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    data-view-type="客服评价"
                                                                    data-unsite="true"
                                                                    data-filter="4,5,6,7"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-weiqianhuowuribaobiao"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">客服评价</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div class="menu-part" roleid="c140101">
                                                                <a
                                                                    class="l-link-item"
                                                                    gridid="13140381-ddbb-0caf-86f8-bf762d601299"
                                                                    data-tabid="11223"
                                                                    data-text="下单统计报表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    data-view-type="下单统计报表"
                                                                    data-unsite="true"
                                                                    data-filter="4,5,6,7"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-weiqianhuowuribaobiao"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">下单统计报表</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>
                                                        <template v-if="tmscode === '87868'">
                                                            <div class="menu-part" roleid="c140123">
                                                                <a
                                                                    class="l-link-item"
                                                                    gridid="e2a93c71-8133-89de-603b-10b6fb735cbf"
                                                                    data-tabid="112"
                                                                    data-text="集包明细报表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    data-view-type="集包明细报表"
                                                                    data-unsite="true"
                                                                    data-filter="4,5,6,7"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-weiqianhuowuribaobiao"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">集包明细报表</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>

                                                        <template v-if='enableOnePriceReconciliation'>
                                                        <div class="menu-part" roleid="c140119">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="queryMarginOrderBillList"
                                                                gridid="1BECC989-1258-4818-B488-E6600D945515"
                                                                data-text="一口价保证金报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-view-type="一口价保证金报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                                data-filter="4,5"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yingyeehuizongbiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">一口价保证金报表</span>
                                                                </span>
                                                            </a>
                                                        </div>

                                                        <div class="menu-part" roleid="c140120">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="queryWalletsFlow"
                                                                gridid="87EFCCE4-866C-4B85-9194-5178710BEAF4"
                                                                data-text="一口价资金明细报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-view-type="一口价资金明细报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                                data-filter="4,5"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yingyeehuizongbiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">一口价资金明细报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        </template>

                                                        <div class="claer"></div>
                                                    </div>
                                                    <template v-if="tmscode === '87868'">
                                                        <div class="menu-class">
                                                            <div class="menu-part" roleid>
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="ccabb4c5-8305-d3eb-ab21-4a193ca1c49e"
                                                                    gridid="ccabb4c5-8305-d3eb-ab21-4a193ca1c49e"
                                                                    data-text="催款客户信息"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    data-view-type="催款客户信息"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-filter="6"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">催款客户信息</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div class="claer"></div>
                                                        </div>
                                                    </template>
                                                    <template v-if="tmscode === '84420'">
                                                        <div class="menu-class">
                                                            <div class="menu-part" roleid>
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="4d50987f-f991-b1be-4f65-f7a7881c77c8"
                                                                    gridid="4d50987f-f991-b1be-4f65-f7a7881c77c8"
                                                                    data-text="小程序收入支出表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    data-view-type="小程序收入支出表"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-filter="4,5,6,7"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">小程序收入支出表</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div class="menu-part" roleid>
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="6b6ea387-33cb-6193-9ef0-1f83f48ea7e3"
                                                                    gridid="6b6ea387-33cb-6193-9ef0-1f83f48ea7e3"
                                                                    data-text="请款单审批报表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    data-view-type="请款单审批报表"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                    data-filter="1,2,3,4,5,6,34"
                                                                    showacc="true"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">请款单审批报表</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div class="claer"></div>
                                                        </div>
                                                    </template>

                                                    <template v-if="tmscode === '79927'">
                                                        <div class="menu-class">
                                                            <div class="menu-part" roleid>
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="CF416409-B940-4ECB-BB9D-2968D2CDA455"
                                                                    gridid="CF416409-B940-4ECB-BB9D-2968D2CDA455"
                                                                    data-text="客户积分报表"
                                                                    data-url="/ReportTpl/reportIntegral"
                                                                    data-type="report"
                                                                    data-view-type="0"
                                                                    data-ajax-url="/tmsApi/interfaceMethod/query/qsp_shipper_outcygs_integral"
                                                                    
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">客户积分报表</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div class="menu-part" roleid>
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="AAF0C827-B9E3-4C25-9FFE-F4AC5C769679"
                                                                    gridid="AAF0C827-B9E3-4C25-9FFE-F4AC5C769679"
                                                                    data-text="承运商积分报表"
                                                                    data-url="/ReportTpl/reportIntegral"
                                                                    data-type="report"
                                                                    data-view-type="1"
                                                                    data-ajax-url="/tmsApi/interfaceMethod/query/qsp_shipper_outcygs_integral"
                                                                   
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">承运商积分报表</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div class="menu-part" roleid>
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="eeddbf14-5ecf-ede5-8714-90dbc24812ee"
                                                                    gridid="eeddbf14-5ecf-ede5-8714-90dbc24812ee"
                                                                    data-text="预警推送报表"
                                                                    data-url="/ReportTpl/reportAlarmPush"
                                                                    data-type="report"
                                                                    data-view-type="预警推送表"
                                                                    data-ajax-url="/reportTpl/getDataCommon"
                                                                   
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">预警推送报表</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div class="claer"></div>
                                                        </div>
                                                    </template>
                                                </div>
                                                <div class="menu-part-body">
                                                    <div class="menu-part-tit">分析类</div>
                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c140301">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="118"
                                                                data-text="货量排名分析表"
                                                                data-url="/ReportTpl/ReportAnalyze"
                                                                data-type="report"
                                                                gridid="741dbb3c-3429-841f-8b2f-c98479be764b"
                                                                data-filter="1,2,3,4,5,6"
                                                                data-view-type="货量排名分析表"
                                                                data-ld="false"
                                                                data-ajax-url="/ReportTpl/ReportAnalyze_Data"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-liruntongjibiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">货量排名分析表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140302">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="119"
                                                                data-text="货量走势分析表"
                                                                data-url="/ReportTpl/ReportAnalyze"
                                                                data-type="report"
                                                                gridid="7b42050d-cc5f-f1b3-67c4-1c2ff366967d"
                                                                data-filter="1,2,3,4"
                                                                data-view-type="货量走势分析表"
                                                                data-ld="false"
                                                                data-ajax-url="/ReportTpl/ReportAnalyze_Data"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-liruntongjibiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">货量走势分析表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140303">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="120"
                                                                data-text="客户流失分析表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                gridid="201c5290-dafc-4356-e4ba-7c6c7873e6c8"
                                                                data-filter="4,5,6,14,11"
                                                                data-view-type="客户流失分析表"
                                                                data-ld="false"
                                                                data-label="{11:'超过'}"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-liruntongjibiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">客户流失分析表</span>
                                                                </span>
                                                            </a>
                                                        </div>

                                                        <div class="menu-part" roleid="c140304" v-if='getCustomizedConfigByKey("report_shipment_collect")'>
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="8d0b8c47-2781-4510-8af1-8b6cd1e325a7"
                                                                    gridid="8d0b8c47-2781-4510-8af1-8b6cd1e325a7"
                                                                    data-text="发货按月汇总表"
                                                                    data-url="/ReportTpl/Shipment"
                                                                    data-type="report"
                                                                    data-view-type="发货按月汇总分析"
                                                                    data-ajax-url="/reportTpl/getDataCommon"
                                                                    
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-yundandaquan"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">发货按月汇总表</span>
                                                                    </span>
                                                                </a>
                                                            </div>

                                                        <template v-if="tmscode === '80292'">
                                                            <div class="menu-part">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="Accountdetail80292"
                                                                    data-text="用户积分明细表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    gridid="70c4a036-c5dc-4f8e-0cf0-c44715ac125c"
                                                                    data-filter="27,4,5,38"
                                                                    data-view-type="用户积分明细表"
                                                                    data-ld="false"
                                                                    data-label="{9:'开单日期'}"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-liruntongjibiao"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">用户积分明细表</span>
                                                                    </span>
                                                                </a>
                                                            </div>

                                                            <div class="menu-part">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="UserAccount80292"
                                                                    data-text="积分用户表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    gridid="db545cf2-44f4-bc53-40ae-0c299d86148b"
                                                                    data-filter="27"
                                                                    data-view-type="积分用户表"
                                                                    data-ld="false"
                                                                    data-label="{9:'开单日期'}"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-liruntongjibiao"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">积分用户表</span>
                                                                    </span>
                                                                </a>
                                                            </div>

                                                            <div class="menu-part">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="Withdrawals80292"
                                                                    data-text="提现申请表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    gridid="cd7249b8-8e00-d099-98ee-55b36d6592c9"
                                                                    data-filter="27,37"
                                                                    data-view-type="提现申请表"
                                                                    data-ld="false"
                                                                    data-label="{9:'开单日期'}"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-liruntongjibiao"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">提现申请表</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>
                                                        <template v-if="tmscode === '79927'">
                                                            <div class="menu-part" roleid="c140304dz">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="120dz"
                                                                    data-text="数据分析表"
                                                                    data-url="/ReportTpl/Index"
                                                                    data-type="report"
                                                                    gridid="c61de6cb-2f97-bbd1-e596-4e3bda414e63"
                                                                    data-filter="9,10,33,6,7"
                                                                    data-view-type="数据分析表"
                                                                    data-ld="false"
                                                                    data-label="{9:'开单日期'}"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-liruntongjibiao"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">数据分析表</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>
                                                        <div class="claer"></div>
                                                    </div>
                                                </div>
                                                <div class="menu-part-body">
                                                    <div class="menu-part-tit">回单类</div>
                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c140401">
                                                            <a
                                                                class="l-link-item"
                                                                roleid="c140401"
                                                                data-tabid="122"
                                                                data-text="回单总账报表"
                                                                data-url="/ReportTpl/Index"
                                                                gridid="20e6bf9b-e49e-2c15-2d43-306c01f74fa8"
                                                                data-type="report"
                                                                data-view-type="回单总账报表"
                                                                data-filter="16,4,5,6,7"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-huidanzongzhangbaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">回单总账报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140402">
                                                            <a
                                                                class="l-link-item"
                                                                roleid="c140402"
                                                                data-tabid="123"
                                                                data-text="未签回单日报表"
                                                                data-url="/ReportTpl/Index"
                                                                gridid="838dce3d-048d-b3ab-0fc3-ccc01acf928f"
                                                                data-type="report"
                                                                data-view-type="未签回单日报表"
                                                                data-unsite="true"
                                                                data-filter="4,5,6,7"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-weiqianhuidanribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">未签回单日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140403">
                                                            <a
                                                                class="l-link-item"
                                                                roleid="c140403"
                                                                data-tabid="124"
                                                                data-text="未寄回单日报表"
                                                                data-url="/ReportTpl/Index"
                                                                gridid="acfdddfd-d73b-5bfe-f8d3-78dad5157f53"
                                                                data-type="report"
                                                                data-view-type="未寄回单日报表"
                                                                data-unsite="true"
                                                                data-filter="4,5,6,7"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-weijihuidanribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">未寄回单日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140404">
                                                            <a
                                                                class="l-link-item"
                                                                roleid="c140404"
                                                                data-tabid="125"
                                                                data-text="未回回单日报表"
                                                                data-url="/ReportTpl/Index"
                                                                gridid="2e0d127a-4574-5d8a-5f00-e7ecf9bb32c0"
                                                                data-type="report"
                                                                data-filter="4,5,6,7"
                                                                data-view-type="未回回单日报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-weishouhuidanribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">未回回单日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140405">
                                                            <a
                                                                class="l-link-item"
                                                                roleid="c140405"
                                                                data-tabid="126"
                                                                data-text="未返回单日报表"
                                                                data-url="/ReportTpl/Index"
                                                                gridid="cfaa18ad-588b-8c0a-4957-37a58043ade3"
                                                                data-type="report"
                                                                data-filter="4,5,6,7"
                                                                data-view-type="未返回单日报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-weifanhuidanribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">未返回单日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>

                                                        <div class="menu-part" roleid="c140409">
                                                            <a
                                                                class="l-link-item"
                                                                roleid="c140409"
                                                                data-tabid="261"
                                                                data-text="回单签收日报表"
                                                                data-url="/ReportTpl/Index"
                                                                gridid="cf98b73a-09c2-7d54-1756-b97211b234a4"
                                                                data-type="report"
                                                                data-filter="30,4,5,6,7"
                                                                data-view-type="回单签收日报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-weifanhuidanribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">回单签收日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>

                                                        <div class="menu-part" roleid="c140406">
                                                            <a
                                                                class="l-link-item"
                                                                roleid="c140406"
                                                                data-tabid="139"
                                                                data-text="回单寄出日报表"
                                                                data-url="/ReportTpl/Index"
                                                                gridid="2b7965f8-f5a1-e8a7-15b6-6174d9c016b3"
                                                                data-type="report"
                                                                data-filter="30,4,5,6,7"
                                                                data-view-type="回单寄出日报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-weifanhuidanribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">回单寄出日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>

                                                        <div class="menu-part" roleid="c140410">
                                                            <a
                                                                class="l-link-item"
                                                                roleid="c140410"
                                                                data-tabid="262"
                                                                data-text="回单返回日报表"
                                                                data-url="/ReportTpl/Index"
                                                                gridid="c057b6a5-8a1a-066b-f1fd-85957eff2eb1"
                                                                data-type="report"
                                                                data-filter="30,4,5,6,7"
                                                                data-view-type="回单返回日报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-weifanhuidanribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">回单返回日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>

                                                        <div class="menu-part" roleid="c140407">
                                                            <a
                                                                class="l-link-item"
                                                                roleid="c140407"
                                                                data-tabid="121"
                                                                data-text="回单返厂日报表"
                                                                data-url="/ReportTpl/Index"
                                                                gridid="1724a29d-a977-157f-de55-2c7be37df6c5"
                                                                data-type="report"
                                                                data-filter="30,4,5,6,7"
                                                                data-view-type="回单返厂日报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-weifanhuidanribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">回单返厂日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <template v-if="tmscode === '87913'">
                                                            <div class="menu-part" roleid="c140408">
                                                                <a
                                                                    class="l-link-item"
                                                                    roleid="c140408"
                                                                    data-tabid="188"
                                                                    data-text="客户发货明细表"
                                                                    data-url="/ReportTpl/Index"
                                                                    gridid="e3ba16cf-26bc-4007-91de-cfc4566669ac"
                                                                    data-type="report"
                                                                    data-filter="30,4,5,6,7"
                                                                    data-view-type="客户发货明细表"
                                                                    data-ajax-url="/ReportTpl/GetDataCommon"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-weifanhuidanribaobiao"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">客户发货明细表</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>
                                                        <div class="claer"></div>
                                                    </div>
                                                </div>
                                                <div class="menu-part-body">
                                                    <div class="menu-part-tit">货款类</div>
                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c140501">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="128"
                                                                data-text="货款总账报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                gridid="b4c0629c-888d-cc31-f51d-ab5903fe4e5e"
                                                                data-filter="4,5,6,7,15"
                                                                data-view-type="货款总账报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-huokuanzongzhangbaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">货款总账报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140502">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="129"
                                                                data-text="未收货款日报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-view-type="未收货款日报表"
                                                                gridid="b5632f1e-965c-5614-16d4-c0ca4f840b79"
                                                                data-unsite="true"
                                                                data-filter="4,5,6,7"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-weishouhuokuanribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">未收货款日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140506">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="1322"
                                                                data-text="已收货款日报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-view-type="已收货款日报表"
                                                                gridid="74ac1781-4f81-af92-6bb4-f25eff8feaa4"
                                                                data-unsite="true"
                                                                data-filter="4,5,6,7"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-weishouhuokuanribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">已收货款日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140503">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="130"
                                                                data-text="未付货款日报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                gridid="ca11c4ad-d59e-9126-ce82-fd8c36d202c1"
                                                                data-view-type="未付货款日报表"
                                                                data-filter="4,5,6,7"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-weishouhuokuanribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">未付货款日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>

                                                        <!-- add by 钟华健 2019-3-18 10:45 -->
                                                        <div class="menu-part" roleid="c140505">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="132"
                                                                data-text="已付货款日报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                gridid="225862bc-c71c-f4d1-1029-86096c43f167"
                                                                data-view-type="已付货款日报表"
                                                                data-filter="23,4,5,6,7"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-weishouhuokuanribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">已付货款日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="claer"></div>
                                                    </div>
                                                    <div class="menu-class">
                                                        <!-- add by 钟华健 2019-3-18 10:45 -->
                                                        <div class="menu-part" roleid="c140504">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="131"
                                                                data-text="货款变更日报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                gridid="6b7819fb-6e95-ca99-a648-bf9e1067703c"
                                                                data-view-type="货款变更日报表"
                                                                data-filter="4,5,6,7"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-huokuanbiangengribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">货款变更日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <!-- add by 潘俊宏 2020-12-16 -->
                                                        <div class="menu-part" roleid="c140507">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="13151"
                                                                data-text="货款挂失日报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                gridid="f194592a-1e71-05a9-40cf-46b137f6c11c"
                                                                data-view-type="货款挂失日报表"
                                                                data-filter="4,5,6,7"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-huokuanbiangengribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">货款挂失日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>

                                                        <div class="claer"></div>
                                                    </div>
                                                </div>
                                                <div class="menu-part-body">
                                                    <div class="menu-part-tit">异常类</div>
                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c140601">
                                                            <a
                                                                class="l-link-item"
                                                                gridid="e9690dbe-f691-161a-66d9-d5bdefcf7f20"
                                                                data-tabid="133"
                                                                data-text="运费异动日报表"
                                                                data-url="/ReportTpl/Index"
                                                                data-type="report"
                                                                data-filter="4,5,6,7"
                                                                data-view-type="运费异动日报表"
                                                                data-ajax-url="/ReportTpl/GetDataCommon"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yunfeiyidongribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">运费异动日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>

                                                        <div class="menu-part" roleid="c140602">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="135"
                                                                data-text="运单修改日报表"
                                                                data-url="/ChangeClassReport/WaybillChangeRecord"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yunfeiyidongribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">运单修改日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140603">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="136"
                                                                data-text="操作日志报表"
                                                                data-url="/ChangeClassReport/OperationLog"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-caozuorizhibaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">操作日志报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140604">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="137"
                                                                data-text="PDA扫码异常报表"
                                                                data-url="/ChangeClassReport/SMabnormal"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yunfeiyidongribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">PDA扫码异常报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c140605">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="SystemChangeRecord"
                                                                data-text="修改日报表"
                                                                data-url="/ChangeClassReport/SystemChangeRecord"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-yunfeiyidongribaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">修改日报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="claer"></div>

                                                        <div class="menu-part" roleid="c140603">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="LoginLog"
                                                                data-text="登录日志报表"
                                                                data-url="/ChangeClassReport/LoginLog"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-caozuorizhibaobiao"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">登录日志报表</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="claer"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>

                                        <li class="small-menu cw-samll-title white-list-module" roleid="c15">
                                            <a class="main-menu-bar" data-tracktxt="财务准备">
                                                <span class="cw-center-li-span">财务准备</span>
                                                <i class="mheadersj"></i>
                                            </a>
                                            <div id="min-menu-cwzb" class="min-menu" style="margin-top:-20px;">
                                                <div class="menu-part-body">
                                                    <div class="menu-class">
                                                        <div class="menu-part" roleid="c1501">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="137"
                                                                data-text="科目定义"
                                                                data-url="/FinancialPreparation/AccountDefinition"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-kemudingyi"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">科目定义</span>
                                                                    <span class="menu-part-summary">设置财务日记账科目</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1502">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="138"
                                                                data-text="科目核销对应"
                                                                data-url="/FinancialPreparation/WriteOffSubject"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-kemuhexiaoduiying"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">科目核销对应</span>
                                                                    <span class="menu-part-summary">科目对应到核销类型,核销自动获取</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1503">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="c1503"
                                                                data-text="定义摘要"
                                                                data-url="/FinancialPreparation/b_dj_content"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-hexiaoquxiangdingyi"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">定义摘要</span>
                                                                    <span class="menu-part-summary">举例:定义摘要</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1504">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="c1504"
                                                                data-text="去向及结算方式"
                                                                data-url="/FinancialPreparation/B_ACCOUNT_CN_BILLTYPE"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-hexiaoquxiangdingyi"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">去向及结算方式</span>
                                                                    <span class="menu-part-summary">举例:去向及结算方式</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1505">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="c1505"
                                                                data-text="银行信息"
                                                                data-url="/bankPrepare/Index"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-kemuhexiaoduiying"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">银行卡信息</span>
                                                                    <span class="menu-part-summary">设置银行卡信息</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" id="hsxmDiv">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="hesuanxiangmu"
                                                                data-text="核算项目"
                                                                data-url="/FinancialPreparation/AccountingItems"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-hexiaoquxiangdingyi"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">核算项目</span>
                                                                    <span class="menu-part-summary">定义核算项目</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" id="zdyDiv" roleid="c1506" style="display: none">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="hesuanxiangmu"
                                                                data-text="自定义上缴账号"
                                                                data-url="/bankPrepare/CustomAccount"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-hexiaoquxiangdingyi"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">自定义上缴账号</span>
                                                                    <span class="menu-part-summary">自定义上缴账号</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <div class="menu-part" roleid="c1507">
                                                            <a
                                                                class="l-link-item"
                                                                data-tabid="c1507"
                                                                data-text="支付方式信息"
                                                                data-url="/bankPrepare/PaymentMethod"
                                                            >
                                                                <i class="l-cw-icon l-icon l-icon-kemuhexiaoduiying"></i>
                                                                <span class="menu-part-content">
                                                                    <span class="menu-part-txt">支付方式</span>
                                                                    <span class="menu-part-summary">设置支付方式信息</span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <!-- 202509281413156109561 86980 自定义隶属站点复制隶属线路功能 但是不显示隶属线路 -->
                                                        <template v-if="getCustomConfig('show_lsxl_btn') || (isPublicLSXLFlag && !getCustomConfig('custom_ls_site_copy_lsxl'))">
                                                            <div class="menu-part" roleid="c1508">
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="c1508"
                                                                    data-text="隶属线路信息"
                                                                    data-url="/FinancialPreparation/Subordinateline"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-kemuhexiaoduiying"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">隶属线路</span>
                                                                        <span class="menu-part-summary">设置隶属线路信息</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>
                                                        <template v-if="tmscode === '84420'">
                                                            <div class="menu-part" roleid>
                                                                <a
                                                                    class="l-link-item"
                                                                    data-tabid="AllowsInspectOtherPleaseInquire"
                                                                    data-text="请款单查看权限设置"
                                                                    data-url="/PermissionGroup/AllowsInspectOtherPleaseInquire"
                                                                >
                                                                    <i class="l-cw-icon l-icon l-icon-kemuhexiaoduiying"></i>
                                                                    <span class="menu-part-content">
                                                                        <span class="menu-part-txt">请款单查看权限设置</span>
                                                                        <span class="menu-part-summary">允许查看其他人的请款单</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </template>
                                                        <div class="claer"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <div class="tuding" onclick="openflowChart('cwzxflowChart',this,'isJava')"></div>
                                    </ul>
                                </div>
                            </div>
                        </li>

                        <li class="big-menu" roleid="baoxian" id="toubao-ele">
                            <a class="l-link">
                                <i class="menu-icon l-icon-toubao"></i>
                                <span>保险</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu zjzh-child-menu">
                                <div id="toubao-tree"></div>
                            </div>
                        </li>
                        <li class="big-menu" roleid="cc1" id="ccgl-new">
                            <a class="l-link">
                                <i class="menu-icon l-icon-cangchu"></i>
                                <span>仓储管理</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu zjzh-child-menu">
                                <div id="ccglTree-new"></div>
                            </div>
                        </li>
                        <template v-if="tmscode === '86583'">
                            <li class="big-menu" roleid id>
                                <a class="l-link">
                                    <i class="menu-icon l-icon-cangchu"></i>
                                    <span>库位管理</span>
                                    <em class="l-icon-jiantou"></em>
                                </a>
                                <div class="child-menu">
                                    <ul>
                                        <li roleid>
                                            <a class="l-link-item" data-tabid="LocationIndex" data-text="库位管理" data-url="/Location/Index">
                                                <span class="child-span">库位管理</span>
                                            </a>
                                        </li>
                                        <li roleid>
                                            <a
                                                class="l-link-item"
                                                data-tabid="OperationRecord"
                                                data-text="上下架记录"
                                                data-url="/Location/OperationRecord"
                                            >
                                                <span class="child-span">上下架记录</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </template>
                        <li class="big-menu ylzy-menu" roleid="l1">
                            <a class="l-link">
                                <i class="menu-icon l-icon-map" style="background: none"></i>
                                <span>货车定位</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu">
                                <div id="huoche-tree"></div>
                            </div>
                        </li>
                        <li class="big-menu" id="slzc" roleid="p1">
                            <a class="l-link">
                                <i class="menu-icon l-icon-ylzy" style="background: none"></i>
                                <span>顺陆找车</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu">
                                <ul>
                                    <li roleid="p101">
                                        <a class="l-link-item" data-tabid data-text="顺陆找车" :data-url="createUrl">
                                            <span class="child-span">顺陆找车</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li class="big-menu" roleid="d1">
                            <a class="l-link">
                                <i class="menu-icon l-icon-zjzh"></i>
                                <span>资金账户</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu zjzh-child-menu">
                                <div id="zjzhTree"></div>
                            </div>
                        </li>
                        <li class="big-menu" roleid="r1" id="ccgl">
                            <a class="l-link">
                                <i class="menu-icon l-icon-cangchu"></i>
                                <span>仓储管理</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu zjzh-child-menu">
                                <div id="ccglTree"></div>
                            </div>
                        </li>

                        <li class="big-menu ylzy-menu" roleid="e1">
                            <a class="l-link">
                                <i class="menu-icon l-icon-ylzy"></i>
                                <span>{{ tmscode === '75313' ? '车辆管理' : '运力资源' }}</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu">
                                <div id="ylzyTree"></div>
                            </div>
                        </li>

                        <li class="big-menu" roleid="f1">
                            <a class="l-link">
                                <i class="menu-icon l-icon-ykgl"></i>
                                <span>油卡管理</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu">
                                <div id="ykglTree"></div>
                            </div>
                        </li>
                        <template v-if="tmscode === '63165' || tmscode === '79358'">
                            <li class="big-menu" roleid>
                                <a class="l-link">
                                    <i class="menu-icon l-icon-ykgl"></i>
                                    <span>油卡油罐</span>
                                    <em class="l-icon-jiantou"></em>
                                </a>
                                <div class="child-menu">
                                    <ul>
                                        <li roleid="f11">
                                            <a class="l-link-item" data-tabid="165" data-text="油罐资料" data-url="/VehicleOilCard/OilcanMaterial">
                                                <span class="child-span">油罐资料</span>
                                            </a>
                                        </li>
                                        <li roleid="f12">
                                            <a class="l-link-item" data-tabid="162" data-text="油罐入库" data-url="/VehicleOilCard/OilcanGive">
                                                <span class="child-span">油罐入库</span>
                                            </a>
                                        </li>
                                        <li roleid="f15">
                                            <a class="l-link-item" data-tabid="163" data-text="油罐出库" data-url="/VehicleOilCard/OilCanOutStorage">
                                                <span class="child-span">油罐出库</span>
                                            </a>
                                        </li>
                                        <li roleid="f17">
                                            <a class="l-link-item" data-tabid="166" data-text="油罐统计" data-url="/VehicleOilCard/OilCanInfo">
                                                <span class="child-span">油罐统计</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </template>
                        <template v-if="tmscode === '85678'">
                            <li class="big-menu" roleid="x1dz">
                                <a class="l-link">
                                    <i class="menu-icon l-icon-ykgl"></i>
                                    <span>出入库批次</span>
                                    <em class="l-icon-jiantou"></em>
                                </a>
                                <div class="child-menu">
                                    <ul>
                                        <li roleid="x101dz">
                                            <a
                                                class="l-link-item"
                                                data-tabid="x101List"
                                                data-text="入库记录"
                                                data-url="/StorageManage77838/InStorage"
                                            >
                                                <span class="child-span">入库记录</span>
                                            </a>
                                        </li>
                                        <li roleid="x102dz">
                                            <a
                                                class="l-link-item"
                                                data-tabid="x102List"
                                                data-text="出库记录"
                                                data-url="/StorageManage77838/OutStorage"
                                            >
                                                <span class="child-span">出库记录</span>
                                            </a>
                                        </li>
                                        <li roleid="x103dz">
                                            <a
                                                class="l-link-item"
                                                data-tabid="x103List"
                                                data-text="运单大全"
                                                data-url="/StorageManage77838/ZxStorage"
                                            >
                                                <span class="child-span">运单大全</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </template>
                        <li class="big-menu wttx-menu" roleid="g1">
                            <a class="l-link">
                                <i class="menu-icon l-icon-wttx"></i>
                                <span>物通天下</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu">
                                <div id="wttxTree"></div>
                            </div>
                        </li>

                        <template v-if="tmscode === '78107'">
                            <li class="big-menu wttx-menu" roleid>
                                <a class="l-link">
                                    <i class="menu-icon l-icon-wttx"></i>
                                    <span>互联互通</span>
                                    <em class="l-icon-jiantou"></em>
                                </a>
                                <div class="child-menu">
                                    <ul>
                                        <li roleid>
                                            <a class="l-link-item" data-tabid="8121" data-text="对接信息" data-url="/hlht/DockingInformation">
                                                <span class="child-span">对接信息</span>
                                            </a>
                                        </li>
                                        <li roleid>
                                            <a class="l-link-item" data-tabid="8122" data-text="下游信息" data-url="/hlht/UpstreamInformation">
                                                <span class="child-span">下游信息</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </template>
                        <template v-if="tmscode === '69605' || tmscode === '80763'">
                            <li class="big-menu wttx-menu" roleid>
                                <a class="l-link">
                                    <i class="menu-icon l-icon-wttx"></i>
                                    <span>互联互通</span>
                                    <em class="l-icon-jiantou"></em>
                                </a>
                                <div class="child-menu">
                                    <ul>
                                        <li roleid>
                                            <a class="l-link-item" data-tabid="8121" data-text="对接信息" data-url="/hlht/DockingInformation">
                                                <span class="child-span">对接信息</span>
                                            </a>
                                        </li>
                                        <li roleid>
                                            <a class="l-link-item" data-tabid="8122" data-text="下游信息" data-url="/hlht/UpstreamInformation">
                                                <span class="child-span">下游信息</span>
                                            </a>
                                        </li>
                                        <li roleid>
                                            <a class="l-link-item" data-tabid="8123" data-text="互联互通计划表" data-url="/hlht/HlhlSchedule">
                                                <span class="child-span">互联互通计划表</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </template>
                        <template v-if="tmscode === '80548' || tmscode === '87931' || tmscode == '97378' || tmscode === '88597'">
                            <li class="big-menu dxzx-menu showBy80548" roleid="r_80548">
                                <a class="l-link">
                                    <i class="menu-icon l-icon-hdgl"></i>
                                    <span>入库管理</span>
                                    <em class="l-icon-jiantou"></em>
                                </a>
                                <div class="child-menu">
                                    <ul>
                                        <li roleid="r1_80548">
                                            <a
                                                class="l-link-item"
                                                data-tabid="qgdl80548"
                                                data-text="清关代理资料"
                                                data-url="/Warehous80548/qgdlinfo80548"
                                            >
                                                <span class="child-span">清关代理资料</span>
                                            </a>
                                        </li>
                                        <li roleid="r2_80548">
                                            <a
                                                class="l-link-item"
                                                data-tabid="rkd80548"
                                                data-text="入库单资料"
                                                data-url="/Warehous80548/rkdinfo80548"
                                            >
                                                <span class="child-span">入库单资料</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </template>
                        <li class="big-menu khzx-menu" roleid="h1">
                            <a class="l-link">
                                <i class="menu-icon l-icon-kfzx"></i>
                                <span>客服中心</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu">
                                <div id="kfglTree"></div>
                            </div>
                        </li>

                        <li class="big-menu" id="is_sb" style="display: none">
                            <a class="l-link">
                                <i class="menu-icon l-icon-ylzy"></i>
                                <span>三包管理</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu zjzh-child-menu">
                                <div id="Tree_SB"></div>
                            </div>
                        </li>
                        <li class="big-menu" roleid="i1">
                            <a class="l-link">
                                <i class="menu-icon l-icon-zkgl"></i>
                                <span>质控管理</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu zjzh-child-menu">
                                <div id="zkmanTree"></div>
                            </div>
                        </li>
                        <li class="big-menu dxzx-menu" roleid id="cdbz-menu" style="display: none">
                            <a class="l-link">
                                <i class="menu-icon l-icon-ylzy"></i>
                                <span>车队报账</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu">
                                <div id="cdbzTree"></div>
                            </div>
                        </li>

                        <li class="big-menu jiesuanTreemenu" roleid="kp1" id="isallowmakebill">
                            <a class="l-link">
                                <i class="menu-icon l-icon-zkgl"></i>
                                <span>开票管理</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu zjzh-child-menu">
                                <div id="jiesuanTree"></div>
                            </div>
                        </li>

                        <li class="big-menu jiesuanTreemenu" roleid="kp2" id="isallowmakebill_sl">
                            <a class="l-link">
                                <i class="menu-icon l-icon-zkgl"></i>
                                <span>双联开票</span>
                                <em class="l-icon-jiantou"></em>
                                <div class="new-tips">它来了</div>
                            </a>
                            <div class="child-menu zjzh-child-menu">
                                <div id="jiesuanTree2"></div>
                            </div>
                        </li>
                        <li class="big-menu dxzx-menu" roleid="j1">
                            <a class="l-link">
                                <i class="menu-icon l-icon-txzx"></i>
                                <span>通讯中心</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu">
                                <div id="txzxTree"></div>
                            </div>
                        </li>
                        <li class="big-menu" roleid="k">
                            <a class="l-link">
                                <i class="menu-icon l-icon-rsxz"></i>
                                <span>人事行政</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu xtsz-child-menu">
                                <div id="rsxzTree"></div>
                            </div>
                        </li>
                         <li class="big-menu" id="end-settle-accsend">
                            <a class="l-link">
                                <i class="menu-icon l-icon-zjzh"></i>
                                <span>末端管控</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu xtsz-child-menu">
                                <div id="costControlTree"></div>
                            </div>
                        </li>
                        <li class="big-menu" style="display: none" id="noticelist91118">
                            <a class="l-link">
                                <i class="menu-icon l-icon-txzx"></i>
                                <span>公司公告</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu xtsz-child-menu">
                                <div id="oaTree"></div>
                            </div>
                        </li>
                        <template v-if="tmscode === '76732'">
                            <li class="big-menu" roleid="o1">
                                <a class="l-link">
                                    <i class="menu-icon l-icon-hdgl"></i>
                                    <span>票据管理</span>
                                    <em class="l-icon-jiantou"></em>
                                </a>
                                <div class="child-menu">
                                    <ul>
                                        <li roleid="o101">
                                            <a
                                                class="l-link-item"
                                                data-tabid="pjly"
                                                data-text="票据领用"
                                                data-url="/BillManagement/BillConsumingList76732"
                                            >
                                                <span class="child-span">票据领用</span>
                                            </a>
                                        </li>
                                        <li roleid="o102">
                                            <a
                                                class="l-link-item"
                                                data-tabid="pjgh"
                                                data-text="票据归还"
                                                data-url="/BillManagement/BillReturnList76732"
                                            >
                                                <span class="child-span">票据归还</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </template>
                        <li class="big-menu dxzx-menu pjgl-outer" roleid="o1">
                            <a class="l-link">
                                <i class="menu-icon l-icon-hdgl"></i>
                                <span>票据管理</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu">
                                <ul>
                                    <li roleid="o101">
                                        <a class="l-link-item" data-tabid="pjlx" data-text="票据类型" data-url="/BillManagement/BillType">
                                            <span class="child-span">票据类型</span>
                                        </a>
                                    </li>
                                    <li roleid="o102">
                                        <a class="l-link-item" data-tabid="pjrk" data-text="票据入库" data-url="/BillManagement/BillWarehousingList">
                                            <span class="child-span">票据入库</span>
                                        </a>
                                    </li>
                                    <li roleid="o103">
                                        <a class="l-link-item" data-tabid="pjff" data-text="票据分发" data-url="/BillManagement/BillDistributionList">
                                            <span class="child-span">票据分发</span>
                                        </a>
                                    </li>
                                    <li roleid="o104">
                                        <a class="l-link-item" data-tabid="pjly" data-text="票据领用" data-url="/BillManagement/BillCollarUseList">
                                            <span class="child-span">票据领用</span>
                                        </a>
                                    </li>
                                    <li roleid="o105">
                                        <a class="l-link-item" data-tabid="pjlb" data-text="票据列表" data-url="/BillManagement/BillList">
                                            <span class="child-span">票据列表</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li class="big-menu dxzx-menu showBy77335" roleid="m1">
                            <a class="l-link">
                                <i class="menu-icon l-icon-hdgl"></i>
                                <span>KPI管理</span>
                                <em class="l-icon-jiantou"></em>
                            </a>
                            <div class="child-menu">
                                <ul>
                                    <li roleid="m11">
                                        <a class="l-link-item" data-tabid="jczlsz" data-text="基础资料设置" data-url="/KPImanage/Index">
                                            <span class="child-span">基础资料设置</span>
                                        </a>
                                    </li>
                                    <li roleid="m12">
                                        <a
                                            class="l-link-item"
                                            data-tabid="kpizbbb"
                                            gridid="458ab52a-b872-c48d-d95f-bc0c58756642"
                                            data-text="指标报表"
                                            data-url="/ReportTpl/Index"
                                            data-type="report"
                                            data-view-type="指标报表"
                                            data-ajax-url="/ReportTpl/GetDataCommon"
                                            data-filter="24,25,4,5,6,7"
                                        >
                                            <span class="child-span">指标报表</span>
                                        </a>
                                    </li>
                                    <li roleid="m13">
                                        <a class="l-link-item" data-tabid="vehiclelv" data-text="满载率指标" data-url="/Vehiclemanage/Index">
                                            <span class="child-span">满载率指标</span>
                                        </a>
                                    </li>
                                    <li roleid="m14">
                                        <a
                                            class="l-link-item"
                                            data-tabid="kpivill"
                                            gridid="30a21f15-f119-f306-38da-a60b818b20db"
                                            data-text="满载率报表"
                                            data-url="/ReportTpl/Index"
                                            data-type="report"
                                            data-view-type="满载率报表"
                                            data-ajax-url="/ReportTpl/GetDataCommon"
                                            data-filter="4,5,6,7,26"
                                        >
                                            <span class="child-span">满载率报表</span>
                                        </a>
                                    </li>
                                    <li roleid="m15">
                                        <a class="l-link-item" data-tabid="cuskpi" data-text="客户对账考核指标" data-url="/CustomerRecKpi/Index">
                                            <span class="child-span">客户对账考核</span>
                                        </a>
                                    </li>
                                    <li roleid="m16">
                                        <a
                                            class="l-link-item"
                                            data-tabid="cuskpirep"
                                            data-text="客户对账考核报表"
                                            data-url="/CustomerRecKpi/CustomerRecReport"
                                        >
                                            <span class="child-span">客户对账报表</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li class="big-menu zjb-menu" roleid="n1">
                            <a class="l-link">
                                <i class="menu-icon l-icon-dygs"></i>
                                <span>定义公司</span>
                                <em class="l-icon-jiantou"></em>
                            </a>

                            <div class="child-menu xtsz-child-menu">
                                <div id="xtszTree"></div>
                            </div>
                        </li>

                        <li class="big-menu zjb-menu" roleid="">
                            <a class="l-link">
                                <i class="menu-icon l-icon-kfzx"></i>
                                <span>更多服务</span>
                                <em class="l-icon-jiantou"></em>
                            </a>

                            <div class="child-menu xtsz-child-menu">
                                <div id="moreServiceTree"></div>
                            </div>
                        </li>

                        <template v-if="tmscode === '79913'">
                            <li class="big-menu wttx-menu" roleid="jck">
                                <a class="l-link">
                                    <i class="menu-icon l-icon-wttx"></i>
                                    <span>基础库</span>
                                    <em class="l-icon-jiantou"></em>
                                </a>
                                <div class="child-menu">
                                    <ul>
                                        <li roleid="jck1">
                                            <a class="l-link-item" data-tabid="8131" data-text="物料库" data-url="/Productlibrary/MaterielMainIndex">
                                                <span class="child-span">物料信息</span>
                                            </a>
                                        </li>
                                        <li roleid="jck2">
                                            <a
                                                class="l-link-item"
                                                data-tabid="8132"
                                                data-text="转换系数"
                                                data-url="/Productlibrary/ChangecoefficientMainIndex"
                                            >
                                                <span class="child-span">转换系数</span>
                                            </a>
                                        </li>
                                        <li roleid="jck3">
                                            <a class="l-link-item" data-tabid="8133" data-text="体积表" data-url="/Productlibrary/SVolumeMainIndex">
                                                <span class="child-span">体积表</span>
                                            </a>
                                        </li>
                                        <li roleid="jck4">
                                            <a
                                                class="l-link-item"
                                                data-tabid="8134"
                                                data-text="价格表"
                                                data-url="/Productlibrary/SPricelistMainIndex"
                                            >
                                                <span class="child-span">价格表</span>
                                            </a>
                                        </li>
                                        <li roleid="jck5">
                                            <a class="l-link-item" data-tabid="8135" data-text="广州计划表" data-url="/Productlibrary/GzCientIndex">
                                                <span class="child-span">广州计划表</span>
                                            </a>
                                        </li>
                                        <li roleid="jck6">
                                            <a class="l-link-item" data-tabid="8136" data-text="合肥计划表" data-url="/Productlibrary/HfClientIndex">
                                                <span class="child-span">合肥计划表</span>
                                            </a>
                                        </li>
                                        <li roleid="jck7">
                                            <a class="l-link-item" data-tabid="8137" data-text="对账列表" data-url="/AccountStatement/MainIndex">
                                                <span class="child-span">对账列表</span>
                                            </a>
                                        </li>
                                        <li roleid="jck8">
                                            <a class="l-link-item" data-tabid="8138" data-text="对账单" data-url="/AccountStatement/StatementIndex">
                                                <span class="child-span">对账单</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </template>

                        <!-- <li class="big-menu menu-lqzxb" roleid="lqzxb">
                            <a class="l-link-item l-link" data-tabid="lqzxb" id="lqzxbId" data-text="蓝桥专线帮" :data-url="lqzxbId">
                                <i class="menu-icon l-icon-ylzy"></i>
                                <span>蓝桥专线帮</span>
                            </a>
                        </li> -->
                        <li class="big-menu menu-mall" v-if="hasBindCYS">
                            <a  class="l-link-item l-link" 
                                data-tabid="9a6c9920-383f-866a-c328-ce9e49de2eaa" 
                                gridid="9a6c9920-383f-866a-c328-ce9e49de2eaa" 
                                data-text="运单时效统计表" 
                                data-url="/ReportTpl/Index"
                                data-type="report"
                                data-view-type="运单时效统计表"
                                data-ajax-url="/ReportTpl/GetDataCommon"
                                data-filter="4,5,6"
                                >
                                <i class="menu-icon l-icon-yundandaquan"></i>
                                <span>运单时效统计表</span>
                            </a>
                        </li>
                    </ul>
                </span>
                <span class="scrollBtn" id="downBtn">
                    <i></i>
                    <u></u>
                </span>
            </div>
            <div position="center">
                <div id="framecenter">
                    <div tabid="home" title="我的主页" showrefresh="true" dblclickclosetab="false" v-if="isSanbaoShow">
                        <iframe frameborder="0" name="home" id="home" :src="indexnewtwo"></iframe>
                    </div>
                </div>
            </div>
        </div>
        <div id="adminTarget" style="display: none">
            <p>【定义公司不允许随便修改】</p>
            <p>【如果确实需要修改，请联系蓝桥工作人员协助您】</p>
            <div class="outer-div">
                <form>
                    <input type="password" class="hidepsw" />
                    <input type="password" id="adminpsw" placeholder="请输入控制密码" />
                </form>
                <a href="javascript:void(0)" id="whatpsw" title="可输入任意一个超级用户的密码。">什么是控制密码？</a>
            </div>
        </div>
        <!-- @Html.Partial("BindingEquipment") -->
        <BindingEquipment />
        <BottomSetting />
        <!-- @Html.Partial("SystemNotification") -->
        <div class="HolidayNotice">
            <div class="HolidayNotice-content" style="text-align: left"></div>
            <!-- 服务顾问向您提供外部投保链接，请不要点击，否则可能会对您的信息安全和资金安全造成危害<br>详情致电13430245392
        为了方便您的客户(货主)快速获取运单节点信息，知晓货物运输状态，您同意，我们会将您录入在蓝桥广达系统中的运单相关信息(具体包括运单日期、货物信息、发货/收货地、经由地、承运专线名称、承运相关人员车牌号、运输状态)提供给货主和/或收货方，具体提供方式为:货主/收货方注册成为蓝桥专线帮小程序用户，输入手机号后可在蓝桥专线帮小程序中查询.
        如您不希望我们将运单信息提供给货主和/或收货方，可通过联系客服关闭这一功能或者告知您的服务顾问。 -->

            <!-- 通知:因系统升级维护（2021年11月18日凌晨4点-7点），届时系统将无法使用，<br />请您提前做好工作安排，给您造成的不便深表歉意！ -->
            <div class="HolidayNotice-btn-outer" style="padding-top: 8px">
                <input type="button" value="知道了" id="HolidayNotice-btn" />
                <input type="checkbox" id="HolidayNotice-input" />
                <label for="HolidayNotice-input">三天内不再提醒</label>
            </div>
        </div>

        <!-- 驾驶证超时弹窗 GteExpiredDocuments -->
        <div id="ExpiredDialog" style="display: none">
            <div id="expiredGrid"></div>
        </div>
        <div id="hideInsurePopConfirm" style="display:none;padding: 24px 22px;">
            <div style="color:#1a1a1a;font-weight:600;font-size:14px;">已创建快捷入口到“文件资源管理器\下载”文件夹内，可自行移动到桌面</div>
            <div style="margin: 12px 0;color: #558115;font-weight:600;font-size:14px;">如图所示：</div>
            <img style="width: 100%;heigth: auto;" id="hideInsurePopConfirmImg" src="" alt="" srcset="">
        </div>
        <div id="authDialog" class="authDialog">
            <div style="font-size: 18px">请将授权代操作码告知客服</div>
            <div style="font-size: 18px;margin-top: 5px">{{  lastTime  }}前有效</div>
            <div style="font-size: 24px;margin-top: 10px; letter-spacing: 5px;color: orange">{{ authCode }}</div>
        </div>

        <!-- 快照弹框打开后联动显示图片 -->
        <HomeKZRelationImg v-if="tmscode == '97993'" />
    </div>
</template>

<script>
import Vue from 'vue'
import HomeKZRelationImg from '@/components/home/HomeKZRelationImg.vue'
import homeHeader from '@/components/home/header.vue'
import popupDefinition from '@/components/home/popupDefinition.vue'
import impowerLogin from '@/components/home/impowerLogin.vue'
import { includeLinkList, includeScriptList, getDataViewByJava, getEVNUrlByWhitelist } from '@/utils/common'
import { CSS_BASEURL, SCRIPT_BASEURL } from '@/utils/enum'
import BottomSetting from '@/components/home/bottomSetting.vue'
import BindingEquipment from '@/components/BindingEquipment/index.vue'
import headList from './headList.js'
import baseInfo from '@/views/loadpage/baseInfo'

import { getAllGrayConfig } from '@/utils/getAllGrayConfig.js'

export default Vue.extend({
    name: 'HomeView',
    components: {
        BottomSetting,
        homeHeader,
        BindingEquipment,
        popupDefinition,
        impowerLogin,
        HomeKZRelationImg
    },
    data() {
        var uu = getNewUserInfo()
        // 重要：将tmscode挂载到top window上，在公共ajax层判断是否同时登录了多个用户
        window.__top_tmscode = uu.TMSCode;
        return {
            isSuperRole: $.getCookie("tmsbsgroupid") == "888",
            hasAIPermission: false, // 是否有AI生图权限
            // 是否绑定承运商
            hasBindCYS: !!(uu.TMSCode == "79927" && uu.cyname),
            isAutoLogin: sessionStorage.getItem('proxyOperateKey') ? true :false,
            isAuthDialogOpen: false,
            authCode: '',
            lastTime: '',
            // showWXOrder: sessionStorage.getItem('wx_orders') == '1',
            userText: !sessionStorage.getItem('proxyOperateKey') ? (uu.TMSCode == "97359" ? `【企业ID：${uu.TMSCode} 河南久大物流有限公司】` : `【企业ID：${uu.TMSCode} 】`) : `【企业ID：${uu.TMSCode} 】(客服代操作)`,
            isSanbaoShow: !sessionStorage.getItem('proxyOperateKey'),
            hasNewWXServiceAd: false,
            showPopupDefinition: false,
            isLoading: true,
            webid: uu.LoginSite,
            tmscode: uu.TMSCode,
            strrole: {},
            rolejson: GetUserAllRoles(true),
            yykhTitle: '',
            cldaTitle: '',
            kpcdTitle: '',
            yykhurl: '',
            headInfo: {
                image: '',
                title: '蓝桥SaaS',
                noIcon: false
            },
            keywords:
                '广州蓝桥广达技术有限公司,蓝桥广达,蓝桥,蓝桥广达总部,蓝桥物流,蓝桥物流软件,蓝桥官网,蓝桥网络,蓝桥财务,蓝桥专线,物流软件,专线物流软件,第三方物流软件,仓储软件,仓储配送软件,PDA软件,PDA扫描,专线货运,第三方货运,物流软件解决方案,专线解决方案,第三方解决方案,仓储配送解决方案,货运软件,物流软件开发,物流软件定制,物流解决方案',
            description:
                '蓝桥广达有限公司是领先的物流企业管理软件及电子商务应用供应商，产品包括ERP、电子商务、专线软件、仓储配送软件、第三方物流软件、物流财务软件等。咨询热线：400-830-3721。',
            lqVersion: '',
            groupid: $.cookie('tmsbsgroupid'),
            txtload: '', // @ViewBag.load 没有数据
            txtLoginSite: $.cookie('tmsbsloginsite'),
            isbaozhangda: '', // @ViewBag.isbaozhangda
            storeData: '', // @ViewBag.store
            logopath: '', // @ViewBag.logopath
            userImeg: '', // @ViewBag.userImeg
            gsname: $.cookie('tmsbsgsname'),
            userName: uu.UserName,
            ruilangprint: $.cookie('ruilangprint'),
            versionName: '插件6.5版本',
            // lqzxbId: '',
            createUrl: '', // tms.common.CommonHelper.CreateFindCarUrl()
            indexnewtwo: $.cookie('HOMEPAGE_VERSION') === 'V2' ? getEVNUrlByWhitelist('/home/indexnewtwoV2') : getEVNUrlByWhitelist('/home/indexnewtwo'),
            argTplObj: {}, //参数设置
            lqBaseUrl: '',
            message: '等待消息...', // 新手引导postmessage
            CookiesNewsReaders: $.cookie('tmsbsnewsreaders'),
            isC9BSCallCar: $.getcookie('TMSversion') === window.LQAPI.C9BS_CALL_CAR,
            isUserEnableOneCarKey: false,
            isEnableLandingDispatch: false, // 是否开启 司机履约管理
            isEnableLandingStowage: false, // 是否开启落地配配载
            enableYsyfModule: false, // 是否开启运单收支调整功能
            isPublicLSXLFlag: false,// 公版隶属线路开关
            showCombinePackage: false,
            hasSelfPickupPermission: window.getCustomizedConfigByKey("customized_storage_location_setting"),
            enableOnePriceReconciliation: localStorage.getItem("enableOnePriceReconciliation") == '1',
            hasBranchReconciliationDetail: window.getCustomizedConfigByKey("branch_reconciliation_detail"),
            enableSecondaryTransfer: uu.TMSCode == "90080" || uu.TMSCode == "82635"
        }
    },
    beforeCreate () {
        if (self == top && top.$ && top.$.cookie("HOMEPAGE_VERSION") == "V2") {
            // 需要跳转到新首页
            location.replace(window.__lq_base_url +"/homeV2/index" + (location.search || ""))
        }
    },
    mounted() {
        window.home_index_vm = this
        this.trackInfoConfig()
        this.isPublicLSXLFlag = this.getPublicLSXLConfig();
        includeLinkList([
            "https://static.ymm56.com/common-lib/swiper/v3.4.2/css/swiper.min.css",
            SCRIPT_BASEURL + '/components/Tooltip/index.css',
            SCRIPT_BASEURL + '/ScriptsPage/lqSwiper/lqswiper.css',
            SCRIPT_BASEURL + '/ScriptsPage/lqSwiper/showDZMD.css',
            CSS_BASEURL + '/home/home.css',
            CSS_BASEURL + '/home/home.extend.css',
            CSS_BASEURL + '/home/home.other.css'
        ])
        this.setHead()
        this.lqBaseUrl = window.__lq_base_url
        var tmsbsuseravatarspath = $.cookie('tmsbsuseravatarspath')
        var res = getDataViewByJava('/home/index', { tmsbsuseravatarspath })
        this.isbaozhangda = res.isbaozhangda || ''
        this.storeData = res.store || ''
        this.logopath = res.logopath || ''
        if (this.logopath && typeof this.logopath == 'string') {
            this.logopath = "https://imagecdn.ymm56.com/ymmfile/static/resource/" + this.logopath.replace('/images/', '').replace('logo/', 'LOGO-')
        }
        // 如果图片有问题，直接用兜底图
        if (res.userImeg == 'https://files2.lqfast.com:28030/') {
            this.userImeg = 'https://imagecdn.ymm56.com/ymmfile/static/resource/c9c56422-dc45-4b2e-86f5-ac17d972f570.png'
        } else {
            this.userImeg = res.userImeg || ''
        }
        this.createUrl = res.findCarUrl || ''
        this.lqVersion = getWebConfigSetting('CssAndJsVersion') || ''
        this.yykhTitle = this.tmscode === '76577' ? '车辆运营费用' : '运营考核'
        this.cldaTitle = this.tmscode === '78219' ? '供应商档案' : '车辆档案'
        this.kpcdTitle = this.tmscode === '78219' ? '订单运营' : '开派车单'
        this.yykhurl = this.tmscode === '80900' ? '/OP/index' : '/TransportResources/OperationExamination'
        // this.lqzxbId = `?wlno=1014&tmscode=${this.tmscode}&parameter=`
        this.argTplObj = getNeedWVData()
        if (this.tmscode === '89167') {
            this.logopath = 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-89167_logo.png'
        }
        // 打印插件判断
        if (this.ruilangprint === 'plugins' && this.ruilangprint === '6,7,19,1225') {
            this.versionName = '插件6.7版本'
        } else if (this.ruilangprint === 'webapp') {
            this.versionName = '插件6.7版本'
        } else {
            this.versionName = '报表客户端'
        }

        includeScriptList(
            [
                // SCRIPT_BASEURL + '/json2.js',
                SCRIPT_BASEURL + '/ScriptsPage/md5.js',
                SCRIPT_BASEURL + '/ScriptsPage/checkBrowser.js',
                SCRIPT_BASEURL + '/ScriptsPage/MQ/mq.js',
                SCRIPT_BASEURL + '/ScriptsPage/MQ/stomp.js',
                SCRIPT_BASEURL + '/components/Tooltip/index.js',
                SCRIPT_BASEURL + '/ScriptsPage/tms-indexDB.js',
                // SCRIPT_BASEURL + '/dingzhi.js',
                SCRIPT_BASEURL + '/ScriptsPage/lqSwiper/lqswiper.js',
                SCRIPT_BASEURL + '/ScriptsPage/lqSwiper/showDZMD.js',
                SCRIPT_BASEURL + '/ScriptsPage/LANtoPrint.js',
                "https://static.ymm56.com/common-lib/swiper/v3.4.2/js/swiper.min.js",
                // SCRIPT_BASEURL + '/HZRecorder.js',
                // SCRIPT_BASEURL + '/tmscodeList.js'
            ],
            true
        ).then(() => {
            includeScriptList([SCRIPT_BASEURL + '/home/home_index.js'], true).then(() => {
                this.isLoading = false
                baseInfo.update() // 重新请求加载页调用失败的接口
                
                // 获取价格体系新版配置
                this.queryBackendPriceConfig()
            })
        })
        // 顺序不要调整， handleAdvInit在前， getGrayConfig在后
        this.handleAdvInit()
        this.getGrayConfig()
        sessionStorage.setItem('hasBindCYS', this.hasBindCYS ? '1': '')
        this.clearRelationStorage()
        this.getAIUserInfo()
        
    },
    methods: {
        switchNewVersion () {
            // 切换新版
            $.javaAjax({
                url: '/user/switchPageVersion',
                type: 'POST',
                dataType: 'json',
                data: {
                configName: 'homepageVersion',
                pageVersion: 'V2'
                },
                success: function (res) { 
                if (res.success) {
                    showMsg({
                    content: "切换新版成功",
                    callback: () => {
                        $.cookie("HOMEPAGE_VERSION", "V2")
                        location.replace(window.location.href.replace('/home/index', '/homeV2/index'))
                    }
                    });
                } else {
                    ShowWARN("切换新版失败, 请稍后重试")
                }
                }
            })
            },
        queryBackendPriceConfig () {
            window.top.BackendPriceConfig = {
                shipperStaticConfig: {},
                consigneeStaticConfig: {},
                lineStaticConfig: {},
                settleAccSendStaticConfig: {},
                transferAccSendStaticConfig: {},
                settleAccOutStaticConfig: {},
                settleAccOutSendStaticConfig: {},
                ysAccOutStaticConfig: {},
                accSendStaticConfig: {},
                accZXStaticConfig: {},
                accFetchStaticConfig: {},
                yfAccOutStaticConfig: {},
                accBGStaticConfig: {},
            }
            // 查询后台的静态配置参数，存储到全局变量，开单页和菜单显隐控制用到
            $.javaAjax({
                url: '/web/priceSystem/queryEnableConfig',
                type: 'POST',
                dataType: 'json',
                isTradeApp: true,
                async: true,
                data: {},
                success: (res) => {
                    if (res.data && Object.keys(res.data).length > 0) {
                        window.top.BackendPriceConfig = res.data
                    }
                    this.setNewPriceMenuShow()
                },
                error: () => {
                    this.setNewPriceMenuShow()
                }
            })
        },
        
        // 根据下发配置来决定各个价格类型的菜单是否露出
        setNewPriceMenuShow() {
            this.$nextTick(()=> {
                let BackendPriceConfig = top.BackendPriceConfig || {}
                if (!BackendPriceConfig.shipperStaticConfig || !BackendPriceConfig.shipperStaticConfig.configEnabled) {
                    // 隐藏发货运价标准
                    $("[roleid=fahuoUnitPriceStandard]").remove();
                }
                if (!BackendPriceConfig.consigneeStaticConfig || !BackendPriceConfig.consigneeStaticConfig.configEnabled) {
                    // 隐藏收货运价标准
                    $("[roleid=shouhuoUnitPriceStandard]").remove();
                }
                if (!BackendPriceConfig.lineStaticConfig || !BackendPriceConfig.lineStaticConfig.configEnabled) {
                    // 隐藏线路运价标准
                    $("[roleid=lineStaticConfig]").remove();
                }
                if (!BackendPriceConfig.settleAccTransStaticConfig || !BackendPriceConfig.settleAccTransStaticConfig.configEnabled) {
                    // 隐藏结算运费标准
                    $("[roleid=settleAccTransStaticConfig]").remove();
                }
                if (!BackendPriceConfig.settleAccSendStaticConfig || !BackendPriceConfig.settleAccSendStaticConfig.configEnabled) {
                    // 隐藏结算送货费标准
                    $("[roleid=settleAccSendStaticConfig]").remove();
                }
                if (!BackendPriceConfig.transferAccSendStaticConfig || !BackendPriceConfig.transferAccSendStaticConfig.configEnabled) {
                    // 隐藏中转送货费标准
                    $("[roleid=transferAccSendStaticConfig]").remove();
                }
                if (!BackendPriceConfig.accSendStaticConfig || !BackendPriceConfig.accSendStaticConfig.configEnabled) {
                    // 隐藏送货费标准
                    $("[roleid=accSendStaticConfig]").remove();
                }
                if (!BackendPriceConfig.settleAccOutStaticConfig || !BackendPriceConfig.settleAccOutStaticConfig.configEnabled) {
                    // 隐藏结算中转费标准
                    $("[roleid=settleAccOutStaticConfig]").remove();
                }
                if (!BackendPriceConfig.settleAccOutSendStaticConfig || !BackendPriceConfig.settleAccOutSendStaticConfig.configEnabled) {
                    // 隐藏结算中转送货费标准
                    $("[roleid=settleAccOutSendStaticConfig]").remove();
                }
                if (!BackendPriceConfig.ysAccOutStaticConfig || !BackendPriceConfig.ysAccOutStaticConfig.configEnabled) {
                    // 隐藏应收中转费标准
                    $("[roleid=ysAccOutStaticConfig]").remove();
                }
                if (!BackendPriceConfig.accZXStaticConfig || !BackendPriceConfig.accZXStaticConfig.configEnabled) {
                    // 隐藏装卸费标准
                    $("[roleid=accZXStaticConfig]").remove();
                }
                if (!BackendPriceConfig.settleAccZXStaticConfig || !BackendPriceConfig.settleAccZXStaticConfig.configEnabled) {
                    // 隐藏结算装卸费标准
                    $("[roleid=settleAccZXStaticConfig]").remove();
                }
                if (!BackendPriceConfig.accFetchStaticConfig || !BackendPriceConfig.accFetchStaticConfig.configEnabled) {
                    // 隐藏接货费标准
                    $("[roleid=accFetchStaticConfig]").remove();
                }
                if (!BackendPriceConfig.yfAccOutStaticConfig || !BackendPriceConfig.yfAccOutStaticConfig.configEnabled) {
                    // 隐藏应付中转费标准
                    $("[roleid=yfAccOutStaticConfig]").remove();
                }
                if (!BackendPriceConfig.accBGStaticConfig || !BackendPriceConfig.accBGStaticConfig.configEnabled) {
                    // 隐藏报关费标准
                    $("[roleid=accBGStaticConfig]").remove();
                }



                // 如果子菜单已全部取出，则隐藏二级菜单
                var $box = $('#newPriceStandardMenu')
                if ($box.length) {
                    var hasLi = $box.find('ul li').length > 0;
                    if (!hasLi) {
                        $box.hide();
                    }
                }
            })
        },
        // AI生图模块获取用户信息
        getAIUserInfo() {
            const configRes = getAllGrayConfig(['LQ_AI_ENTRANCE'])
            this.hasAIPermission = configRes && configRes.LQ_AI_ENTRANCE && configRes.LQ_AI_ENTRANCE.enable
            $.javaAjax({
                url: '/web/ai/account/info/query',
                type: 'POST',
                dataType: 'json',
                isTradeApp: true,
                async: true,
                data: {},
                success: (res)=> {
                    if (res.success) {
                        if (res.data) {
                            sessionStorage.setItem('AICompanyTitle', res.data.companyName)
                        }
                    } else {
                        window.ShowERR(res.errmsg);
                    }
                }
            });
        },
        getAuthCode () {
            if(this.isAuthDialogOpen) return
            $.javaAjax({
                type: "POST",
                url: "/proxy/operate/getAuthCode",
                data: { },
                dataType: 'json',
                async: true,
                cache: false,
                error: (XMLHttpRequest, textStatus, errorThrown) => {
                    alert("失败1:" + errorThrown);
                },
                success: (res) => {
                    if (res.success) {
                        this.lastTime = res.data.expireTime
                        this.authCode = res.data.authCode
                        this.isAuthDialogOpen = true
                        $.ligerDialog.open({
                            title: `提示${getNewUserInfo().TMSCode}`,
                            modal: false,
                            target: $("#authDialog"),
                            width: 300,
                            height: 233,
                            allowClose: false,
                            buttons: [
                                { text: '关闭', onclick:  (item, dialog) => { dialog.hide();this.isAuthDialogOpen = false } }
                            ],
                            isResize: true
                        });
                    } else {
                        showMsg({content: res.message , time: 3000});
                    }
                }
            });
        },
        handleAdvInit() {
            getAllGrayConfig([], true)
            this.openChangeAgentNotice()
        },
        checkShowAgentChangeNotice () {
            // 判断是否勾选了不在提示
            const u = window.LQAPI.getUserInfo();
            const obj = JSON.parse(window.localStorage.getItem('change_agent_tips') || '{}')
            const key = u.TMSCode + "_" + u.UserId;
            if (obj[key] == '1') {
                return false;
            }
            var needPopStr = '["95665","65003","65907","63935","86610","95708","95725","95751","95757","86013","82982","86869","86797","86883","86026","85010","89998","93257","51366","53016","41271","66576","75865","76106","79285","75853","76013","73820","73787","75051","52614","56976","76007","89834","52628","87965","52243","71913","68771","66915","68239","68256","68113","75015","67930","67993","68983","67332","83032","67759","68595","85973","53929","81035","81310","69059","68010","70593","71805","71796","70271","63373","57281","69965","67771","70177","70932","72380","69891","87901","68883","89410","69121","57327","64064","56472","62009","64729","60438","71836","57348","63933","57611","63565","83315","52456","67319","85830","62491","68738","40792","60023","60074","53621","69238","89822","67085","63717","63944","63723","63710","65699","52640","88983","70661","63005","88461","71856","64756","55824","60930","71928","69598","86195","59934","66127","57064","50319","50975","61338","65903","65705","61358","60941","65873","60383","61924","87727","89260","66380","71573","88423","53642","60541","63101","70305","61915","86498","61792","69998","61337","89139","61607","65727","64484","60146","61990","65890","65723","61752","65916","55929","71653","88787","65676","58234","87889","86190","73069","84837","87037","86978","86552","84232","86716","87856","89023","90060","90296","91279","91912","92028","92668","92785","93330","92928","93003","93087","93178","93217","93232","93216","93221","93230","93236","93765","95770","95792","95830","93921","95008","95011","95023","95086","95102","96101","95217","95535","95591","96950","96961","99021","96289","99623","99531","99203","99220","98875","97561","97787","97823","96586","98332","82384","82664","82674","97059","97067","97092","97258","96903","97263","97308","97953","98177","98270","98278","98307"]'
            if (needPopStr.indexOf(u.TMSCode) != -1) {
                return true
            }
            return false
        },
        // 代理商调整弹框
        openChangeAgentNotice() {
            const res = this.checkShowAgentChangeNotice()
            if (!res) {
                return false
            }
            this.openAgentChangeDialog()
        },
        openAgentChangeDialog() {
            const htmlctn = `
                <div>
                    <div style="display:flex;align-items:center;justify-content:center;">
                        <img style="width:478px;height:178px;" src="https://imagecdn.ymm56.com/ymmfile/static/resource/e31b5207-652b-4b14-ab9d-9f9044c1f429.png" alt="" srcset="" />
                    </div>
                    <div style="margin: 10px 0;display:flex;align-items:center;justify-content:center;">
                        <input type="checkbox" name="change_agent_tips" id="change_agent_tips">
                        <label style="padding-left:4px;" for="change_agent_tips">近期不再提示</label>
                    </div>
                </div>
            `
            window.$LqConfirm(htmlctn, {
                confirmButtonText: '关闭',
                showCancelButton: false,
                dangerouslyUseHTMLString: true,
                distinguishCancelAndClose: true,
                customClass: 'w-560 h-auto w-max',
                callback: function(action, instance) {
                    // 记录用户的操作
                    const u = window.LQAPI.getUserInfo();
                    const obj = JSON.parse(window.localStorage.getItem('change_agent_tips') || '{}')
                    const key = u.TMSCode + "_" + u.UserId;
                    obj[key] = $('#change_agent_tips').prop('checked') ? '1' : '0'
                    window.localStorage.setItem('change_agent_tips', JSON.stringify(obj))
                }
            })
        },
        getGrayConfig () {
            var configRes = getAllGrayConfig(['BILLING_TYD_ADD_URGENT'])
            localStorage.removeItem('isUrgent')
            var isUrgent = configRes && configRes.BILLING_TYD_ADD_URGENT && configRes.BILLING_TYD_ADD_URGENT.enable
            localStorage.setItem('isUrgent', JSON.stringify(isUrgent || false))
            
            var _this = this
            $.javaAjax({
                url:"/clienteleService/getConfig", 
                isSearchApp: true,
                data: {},
                success: function (res) {
                    if (res.success) {
                        localStorage.removeItem('configMap')
                        var configMap = res.data && res.data.map
                        localStorage.setItem('configMap', JSON.stringify(configMap))
                        // 判断是否出添加微信新手引导
                        _this.handleWXNewGuide(configMap)

                        // 判断智能配载

                        // 判断是否开启称重量方,智能配载
                        if (res.data && res.data.smartStowageFunction) {
                            sessionStorage.setItem("WEIGHT_MEASURE",res.data.smartStowageFunction.WEIGHT_MEASURE)//称重量方
                            sessionStorage.setItem("SMART_PZ",res.data.smartStowageFunction.LOAD)//智能配载
                        } else {
                            sessionStorage.removeItem("WEIGHT_MEASURE")
                            sessionStorage.removeItem("SMART_PZ")
                        }
                        // 公司维度是控制操作员档案有没有入口，用户维度的是控制菜单展不展示
                        // 判断用户维度询价调车
                        if (res.data && res.data.userEnableOneCarKey) {
                            _this.isUserEnableOneCarKey = true
                            localStorage.setItem("isUserEnableOneCarKey", '1')
                        } else {
                            _this.isUserEnableOneCarKey = false
                            localStorage.removeItem("isUserEnableOneCarKey")
                        }
                        // 判断公司维度询价调车
                        if (res.data && res.data.enableOneCarKey) {
                            localStorage.setItem("isEnableOneCarKey", '1')
                        } else {
                            localStorage.removeItem("isEnableOneCarKey")
                        }

                        // 是否开启 司机履约管理
                        if (res.data && res.data.isEnableLandingDispatch) {
                            _this.isEnableLandingDispatch = true
                            localStorage.setItem("isEnableLandingDispatch", '1')
                        } else {
                            _this.isEnableLandingDispatch = false
                            localStorage.removeItem("isEnableLandingDispatch")
                        }

                        // 是否开启物通天下-费用回传
                        if (res.data && res.data.enableWttxFeePush) {
                            console.log('是否开启物通天下-费用回传=====》')
                            localStorage.setItem("enableWttxFeePush", '1')
                        } else {
                            localStorage.removeItem("enableWttxFeePush")
                        }

                        // 是否开启落地配配载功能
                        if (res.data && res.data.isEnableLandingStowage) {
                            _this.isEnableLandingStowage = true
                            localStorage.setItem("isEnableLandingStowage", '1')
                        } else {
                            _this.isEnableLandingStowage = false
                            localStorage.removeItem("isEnableLandingStowage")
                        }

                        // 是否开启运单收支调整功能
                        if (res.data && res.data.enableYsyfModule) {
                            _this.enableYsyfModule = true
                            localStorage.setItem("enableYsyfModule", '1')
                        } else {
                            _this.enableYsyfModule = false
                            localStorage.removeItem("enableYsyfModule")
                        }

                        // 开启拼单包裹
                        if (res.data && res.data.enableCombinePackage) {
                            _this.showCombinePackage = true
                        } else {
                            _this.showCombinePackage = false
                        }
                        // 是否开启 客户对账折扣功能
                        if (res.data && res.data.enableCustStmtDisc) {
                            localStorage.setItem("enableCustStmtDisc", '1');
                        } else {
                            localStorage.removeItem("enableCustStmtDisc");
                        }
                         // 是否开启 一口价对账功能
                        if (res.data && res.data.reconciliationConfigMap && res.data.reconciliationConfigMap.onePrice && res.data.reconciliationConfigMap.onePrice.enabled) {
                            localStorage.setItem("enableOnePriceReconciliation", '1');
                            _this.enableOnePriceReconciliation = true
                        } else {
                            localStorage.removeItem("enableOnePriceReconciliation");
                            _this.enableOnePriceReconciliation = false
                        }
                    }
                }
            })
        },
        openNextTip() {
            var configMap = JSON.parse(localStorage.getItem('configMap') || '{}')
            var newWxGuideService = configMap.newWxGuideService || {}
            var dialog = $.ligerDialog.open({
                title: '新手服务',
                modal: false,
                width: 514,
                height: 475,
                allowClose: false,
                content: '<div class="wxNewGuideNext"><div style="margin: 28px 0 19px 0;">' + (newWxGuideService.nextTimeFindTips || '下次可在此处快速找到官方客服微信联系方式：') + '</div><img style="border-radius:20px;width:471px;height:299px;" src="https://imagecdn.ymm56.com/ymmfile/static/resource/1cc051b1-ac0e-4e35-8ec3-31850688f71a.png" /><div style="color:#FF3333;margin-top:8px;">弹框<span id="wxNewGuideCountDown">5秒</span>后自动关闭</div><div>'
            })
            var maxCount = 5
            var tt = setInterval(function() {
                maxCount--
                $('#wxNewGuideCountDown').html(maxCount + '秒')
                if (maxCount<= 0) {
                    dialog.close()
                    clearInterval(tt)
                }
            }, 1000);
        },
        updateNoMoreTips() {
            // 走接口请求
            $.javaAjax({
                url: '/web/clienteleService/updateGuideStatus',
                type: 'POST',
                isSearchApp: true,
                data: {
                    enable: true
                },
                success: function() {
                },
                error: function() {
                }
            })
        },
        handleWXNewGuide(configMap) {
            if (!configMap || !configMap.newWxGuideService) {
                this.showPopupDefinition = true
                return
            }
            var needShow = false
            var showCheckBox = false
            $.javaAjax({
                url: '/web/clienteleService/getNewWxGuideServiceConfig',
                type: 'POST',
                isSearchApp: true,
                async: false,
                data: {},
                success: function(res) {
                    if (res.success && res.data && res.data.showNewWxGuideService) {
                        needShow = true
                        showCheckBox = res.data.showDisableGuide
                        // 曝光埋点
                        window.lib && window.lib.track.viewOnce('qr_greenHand', 'Main', {
                            pageName: 'lanqiao_saas_home'
                        })
                    }
                }
            })
            var _this = this
            if (needShow) {
                this.hasNewWXServiceAd = true
                $.ligerDialog.open({
                    title: '新手服务',
                    modal: false,
                    width: 514,
                    height: showCheckBox ? 545 : 525,
                    url: '/weCom/weCom?isNewGuide=1&showCheckBox=' + (showCheckBox ? '1': '0'),
                    name: 'weCom',
                    closeClickName: function(param) {
                        // 打开新的弹框
                        _this.openNextTip()
                        if (param && param.businessOpts && param.businessOpts.noMoreTips) {
                            _this.updateNoMoreTips()
                        }
                    }
                });
            }
            this.$nextTick(function() {
                _this.showPopupDefinition = true
            })
        },
        trackInfoConfig() {
            var uu = getNewUserInfo()
            window.lib &&
                window.lib.track.setConfig({
                    userId: uu.TMSCode,
                    adminName: uu.adminname,
                    userName: uu.UserName,
                    company_id: uu.TMSCode,
                    UID: uu.adminname
                })
        },
        privacyButtons() {
            this.$refs.impowerLogin.privacyShow()
        },
        noticeButtons(obj) {
            this.$refs.HomeHeader.InitializeButtons(obj)
        },
        setHead() {
            var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
            link.type = 'image/vnd.microsoft.icon'
            var headData = headList.filter(item => item.tmscode === this.tmscode)
            if (headData && headData.length > 0) {
                this.headInfo = headData[0]
            }
            // console.log('this.headInfo', this.headInfo);
            link.rel = this.headInfo.noIcon ? 'icon' : 'shortcut icon'
            link.href = this.headInfo.image
                ? this.headInfo.image.startsWith('https')
                    ? this.headInfo.image
                    : `https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-${this.headInfo.image}`
                : '' //标签栏图标地址
            document.getElementsByTagName('head')[0].appendChild(link)
            document.title = this.headInfo.title || '蓝桥saas' //标签栏名称
        },
        getEVNUrlByWhitelist,

        onErrorImg($event) {
            $event.target.src = 'https://imagecdn.ymm56.com/ymmfile/static/resource/c9c56422-dc45-4b2e-86f5-ac17d972f570.png'
        },
        // 在最外层页面刷新的时候清楚一些业务缓存
        clearRelationStorage() {
            sessionStorage.removeItem('use_simple_fast_bill')
        },
        getCustomConfig(key) {
            return window.getCustomizedConfigByKey(key) || false;
        },
        getPublicLSXLConfig(){
            const configRes = window.LQAPI.getAllGrayConfig(["LINE_LS"]);
            return configRes && configRes.LINE_LS && configRes.LINE_LS.enable
        }
    }
})
</script>
<style scoped>
.center-container {
    display: flex;
}
/* 财务中心布局 s*/
.cwzx-menu .shell-menu-ul.financial-menu-ul .small-menu .min-menu {
    height: auto !important;
    width: calc(100%);
    overflow-x: scroll;
    overflow-y: scroll;
    left: 0 !important;
    background: white;
    max-height: calc(100vh - 158px);
    margin-top: 25px;
    padding-left: 40px;
    min-height: 617px;
    box-sizing: border-box;
}
.financial-menu-content.shell-menu {
    width: calc(100vw - 158px);
    box-sizing: border-box;
    /* max-width: 1420px; */
    height: auto !important;
    background: #f5f5f5;
    border-radius: 0;
    padding: 0;
    min-width: 950px;
    /* overflow-x: hidden; */
}
.financial-menu-content .center-container > ul {
    width: 100%;
    position: relative;
}

.financial-menu-content .menu-part-body {
  width: auto
}
/* 财务中心广告布局 e*/
.center-container-ul {
    position: relative;
    width: 715px;
    background: #ffffff;
    padding: 0 20px 30px 0;
}

.has-adv-content {
    width: auto !important;
    height: auto !important;
    /* background: #f5f5f5; */
    /* overflow: hidden; */
    padding: 0;
    border-radius: 2px;
    min-width: 715px;
}
</style>
<style>
.PayWarn {
    z-index: 20001 !important;
}

.PayWarn .l-dialog-title {
    color: red;
    font-size: 20px;
    font-weight: bolder;
}

.PayWarnContent {
    color: red;
    font-size: 20px;
    font-weight: bolder;
    margin: 10px;
}

#adminTarget p {
    line-height: 30px;
    font-size: 12px;
    color: red;
    text-align: center;
}

#adminpsw {
    height: 30px;
    line-height: 30px;
    border: 1px solid #ddd;
    width: 100%;
    text-indent: 24px;
}

#adminTarget a {
    line-height: 30px;
    color: #666;
}

.outer-div {
    width: 90%;
    margin: 0 auto;
}

.hidepsw {
    height: 1px;
    border: 0 none;
    visibility: hidden;
}

@media screen and (max-height: 768px) {
    .yyzx-menu .shell-menu {
        top: -65px;
        z-index: 9001;
    }

    .cwzx-menu .shell-menu {
        top: -50px;
        z-index: 9001;
    }

    .lbzx-menu .shell-menu {
        top: 0px;
        z-index: 9001;
    }
}

#tipDialog {
    right: 20px;
}

#tipDialog .l-dialog-content {
    min-height: 130px;
    max-height: 400px;
    padding: 5px;
    cursor: pointer;
}

.l-link em {
    opacity: 0;
}

.big-menu .l-link {
    position: relative;
}

.bghover a.l-link:before {
    border-left-width: 5px;
    border-left-style: solid;
    border-left-color: #03a9f4;
    width: 0;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    content: '';
    display: block;
}

.bghover .l-link em {
    opacity: 1;
}

#hsxmDiv {
    display: none;
}

#jiesuanTree {
    padding-left: 12px;
}

.showBy77335,
.showBy79808 {
    display: none;
}

.unitList {
    color: red;
    line-height: 25px;
    margin-left: 15px;
}

.newnotice_dialog {
    position: fixed;
    background: #fff;
    box-shadow: 0 6px 16px 10px rgba(0, 0, 0, 0.3);
    width: 350px;
    bottom: 7px;
    right: -100px;
    z-index: 9999999;
    font-family: microsoft YaHei, tahoma, arial, 宋体b8b\4f53 !important;
}

.newnotice_dialog header {
    height: 38px;
    line-height: 38px;
    padding: 0 10px;
    background: #f5f5f5;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
}

.system-alret-lk {
    display: inline-block;
    text-decoration: none;
    font-weight: 600;
    color: red;
}

.userimgBig {
    border-radius: 50%;
    border: 2px solid #fff;
    box-sizing: border-box;
}

.menuTag {
    position: fixed;
    left: 50px;
    top: 95px;
    font-size: 12px;
    background: #2f4554;
    color: #fff;
    z-index: 9999999;
    height: 24px;
    line-height: 24px;
    padding: 0 8px;
    border-radius: 3px;
    font-size: 12px;
    display: none;
    box-shadow: 0px 0px 12px 2px rgba(0, 0, 0, 0.5);
}

.menuTag .l-icon-lArrow {
    position: absolute;
    left: -10px;
    top: 2px !important;
    height: 24px;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
}

.logo-outer-p {
    position: relative;
    float: left;
    padding-top: 3px;
}

.logo-outer span {
    display: block;
    line-height: 18px;
}

#DuetoCar .l-dialog-content p {
    padding: 5px;
    color: red;
    cursor: pointer;
}

#DuetoInmain .l-dialog-content p {
    padding: 5px;
    color: red;
    cursor: pointer;
}

#DuetoInmain .l-dialog-content:hover {
    text-decoration: underline;
    opacity: 0.8;
}

#DuetoIndetail .l-dialog-content p {
    padding: 5px;
    color: red;
    cursor: pointer;
}

#DuetoIndetail .l-dialog-content:hover {
    text-decoration: underline;
    opacity: 0.8;
}

.hideLeftMenu .new-tips {
    display: none;
}

.new-tips {
    position: absolute;
    right: 2px;
    top: -3px;
    background: #ff5722;
    font-size: 12px;
    padding: 2px 5px;
    color: #fff;
    border-radius: 50px 50px 50px 0;
}

.HolidayNotice {
    position: fixed;
    left: 50%;
    top: 8px;
    background: #fff;
    text-align: center;
    z-index: 999999;
    padding: 10px 10px;
    transform: translateX(-50%);
    border-radius: 4px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.8);
    font-size: 16px;
    text-indent: 30px;
    width: 800px;
    line-height: 30px;
    border: 4px solid #ff5722;
    display: none;
}

#HolidayNotice-input {
    vertical-align: middle;
    cursor: pointer;
}

.HolidayNotice label {
    vertical-align: middle;
    font-size: 12px;
    cursor: pointer;
}

#HolidayNotice-btn {
    margin-right: 8px;
    vertical-align: middle;
    background: #ff5722;
    border: 1px solid #ff5722;
    font-size: 12px;
    text-align: center;
    width: 60px;
    height: 26px;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
}

#HolidayNotice-btn:hover {
    opacity: 0.8;
}

.jiesuanTreemenu {
    display: none;
}

.ceshitips {
    position: absolute;
    color: red;
    left: -70px;
    border: 2px solid red;
    padding: 0 10px;
    font-size: 16px;
    font-weight: bolder;
}

#tooltip {
    position: absolute;
    top: 5px;
    display: inline-block;
    text-decoration: none;
    width: 12px;
    height: 12px;
    line-height: 12px;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    border: solid 1px orange;
    border-radius: 50%;
    color: orange;
    vertical-align: 2px;
}
/* .tool_tip {
            left: 148px !important;
        } */
.l-tree {
    padding-left: 10px;
}

.btn-box {
    overflow: hidden;
}
</style>
<style scoped>
#app {
    height: 100%;
    min-width: 1300px;
    min-height: 604px;
}
.kxglMenu .item-menu a > span {
    vertical-align: top;
}

.is-loading::after {
    content: '';
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
}
.auth-swap {
    float: right;
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
}
.auth-swap-text {
    font-size: 14px;
    color: #354554;
    margin-top: 2px
}
.authDialog {
    display: none;
    padding-top: 30px;
    text-align: center;
}
</style>
